// // src/components/Navbar.js
// import React from 'react';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
// import logo from './logo.png'; // use the same logo image
// import './Navbar.css';

// const AppNavbar = () => (
//   <Navbar bg="light" expand="lg" sticky="top">
//     <Container>
//       <Navbar.Brand href="/">
//         <img src={logo} height="50" alt="Lions India Logo" />
//       </Navbar.Brand>
//       <Navbar.Toggle aria-controls="basic-navbar-nav" />
//       <Navbar.Collapse id="basic-navbar-nav">
//         <Nav className="me-auto">
//           <Nav.Link href="/membership">Membership</Nav.Link>
//           <NavDropdown title="Magazine" id="magazine-dropdown">
//             <NavDropdown.Item href="/magazine/digital">Digital Magazine</NavDropdown.Item>
//             <NavDropdown.Item href="/magazine/flipbook">Flipbook Magazine</NavDropdown.Item>
//             <NavDropdown.Item href="/magazine/hindi">Hindi Magazine</NavDropdown.Item>
//           </NavDropdown>
//           <NavDropdown title="Leadership" id="leadership-dropdown">
//             <NavDropdown.Item href="/leadership/events">Leadership Events</NavDropdown.Item>
//             <NavDropdown.Item href="/leadership/resources">Resources</NavDropdown.Item>
//             <NavDropdown.Divider />
//             <NavDropdown.Item href="/leadership/team">Leadership Team</NavDropdown.Item>
//           </NavDropdown>
//           {/* Continue with other menus: Marketing, LCIF, CSR, etc. */}
//           <Nav.Link href="/contact">Contact</Nav.Link>
//         </Nav>
//       </Navbar.Collapse>
//     </Container>
//   </Navbar>
// );

// export default AppNavbar;

// import React, { useState } from 'react';
// import './Navbar.css';
// import logo from './logo.png'; // same Lions India logo

// export default function AppNavbar() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   return (
//     <header className="li-header">
//       <div className="li-nav-container">
//         <a href="/" className="li-logo">
//           <img src={logo} alt="Lions India logo" />
//         </a>

//         <button
//           className="li-burger"
//           onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//         >
//           <span className="li-burger-line" />
//           <span className="li-burger-line" />
//           <span className="li-burger-line" />
//         </button>

//         <nav className={`li-menu${mobileMenuOpen ? ' open' : ''}`}>
//           <ul>
//             <li><a href="/membership">Membership</a></li>
//             <li className="dropdown">
//               <a href="#">Magazine</a>
//               <ul className="dropdown-menu">
//                 <li><a href="/magazine/digital">Digital Magazine</a></li>
//                 <li><a href="/magazine/flipbook">Flipbook Magazine</a></li>
//                 <li><a href="/magazine/hindi">Hindi Magazine</a></li>
//               </ul>
//             </li>
//             <li className="dropdown">
//               <a href="#">Leadership</a>
//               <ul className="dropdown-menu">
//                 <li><a href="/leadership/events">Leadership Events</a></li>
//                 <li><a href="/leadership/resources">Resources</a></li>
//                 <li><a href="/leadership/team">Leadership Team</a></li>
//               </ul>
//             </li>
//             <li><a href="/marketing">Marketing</a></li>
//             <li><a href="/lcif">LCIF</a></li>
//             <li><a href="/csr">CSR</a></li>
//             <li><a href="/contact">Contact</a></li>
//           </ul>
//         </nav>
//       </div>
//     </header>
//   );
// }


// import React, { useState, useEffect, useRef } from 'react';
// import './Navbar.css';
// import logo from './logo.png';

// export default function AppNavbar() {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const navRef = useRef();

//   // Close mobile menu on outside click
//   useEffect(() => {
//     const handleClick = e => {
//       if (mobileOpen && navRef.current && !navRef.current.contains(e.target)) {
//         setMobileOpen(false);
//       }
//     };
//     document.addEventListener('click', handleClick);
//     return () => document.removeEventListener('click', handleClick);
//   }, [mobileOpen]);

//   const menu = [
//     { label: 'Membership', items: [
//       { label:'Membership', link:'#' },
//       { label:'Resources', items: [
//         { label:'Types of Members', link:'#' },
//         /* all sub items as per site... */
//       ]}
//     ]},
//     { label: 'Magazine', items: [
//       { label:'Digital Magazine', link:'#' },
//       /* ... */
//     ]},
//     /* Add rest: Leadership with submenus, Marketing, LCIF, CSR, LEO, Club Support, Service, Events, History, Directory */
//   ];

//   const renderMenu = (items) => (
//     <ul>
//       {items.map((i, idx) => (
//         <li key={idx} className={i.items ? 'dropdown' : ''}>
//           <a href={i.link || '#'}>{i.label}</a>
//           {i.items && renderMenu(i.items)}
//         </li>
//       ))}
//     </ul>
//   );

//   return (
//     <header className="li-header">
//       <div className="li-container" ref={navRef}>
//         <a href="/" className="li-logo"><img src={logo} alt="Lions India" /></a>
//         <button className="li-burger" onClick={()=>setMobileOpen(!mobileOpen)}>
//           <span/><span/><span/>
//         </button>
//         <nav className={`li-nav ${mobileOpen? 'open':''}`}>
//           {renderMenu(menu)}
//         </nav>
//       </div>
//     </header>
//   );
// }


// import React, { useState } from 'react';
// import './Navbar.css';
// import logo from './logo.png';

// const menuItems = [
//   {
//     label: 'Membership',
//     children: [
//       {
//         label: 'Member Resources',
//         children: [
//           { label: 'Club Officer Manuals', link: '#' },
//           { label: 'Membership Forms', link: '#' },
//         ],
//       },
//       { label: 'Membership Types', link: '#' },
//     ],
//   },
//   {
//     label: 'Magazine',
//     children: [
//       { label: 'Digital Magazine', link: '#' },
//       { label: 'Hindi Edition', link: '#' },
//     ],
//   },
//   {
//     label: 'Leadership',
//     children: [
//       {
//         label: 'Events',
//         children: [
//           { label: 'Annual Meet', link: '#' },
//           { label: 'Leadership Camp', link: '#' },
//         ],
//       },
//       {
//         label: 'Resources',
//         children: [
//           { label: 'Downloads', link: '#' },
//           { label: 'Presentations', link: '#' },
//         ],
//       },
//     ],
//   },
// ];

// export default function AppNavbar() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const renderMenu = (items) => (
//     <ul className="menu">
//       {items.map((item, index) => (
//         <li key={index} className={item.children ? 'has-sub' : ''}>
//           <a href={item.link || '#'}>{item.label}</a>
//           {item.children && (
//             <div className="dropdown">
//               <span className="dropdown-arrow" />
//               {renderMenu(item.children)}
//             </div>
//           )}
//         </li>
//       ))}
//     </ul>
//   );

//   return (
//     <header className="nav-header">
//       <div className="nav-container">
//         <a href="/" className="nav-logo">
//           <img src={logo} alt="Logo" />
//         </a>
//         <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>
//           <span /><span /><span />
//         </button>
//         <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
//           {renderMenu(menuItems)}
//         </nav>
//       </div>
//     </header>
//   );
// }

// import React, { useState } from 'react';
// import './Navbar.css';
// import logo from './logo.png';

// const menuItems = [
//   {
//     label: 'Membership',
//     children: [
//       {
//         label: 'Member Resources',
//         children: [
//           { label: 'Club Officer Manuals', link: '#' },
//           { label: 'Membership Forms', link: '#' },
//         ],
//       },
//       { label: 'Membership Types', link: '#' },
//     ],
//   },
//   {
//     label: 'Magazine',
//     children: [
//       { label: 'Digital Magazine', link: '#' },
//       { label: 'Hindi Edition', link: '#' },
//     ],
//   },
//   {
//     label: 'Leadership',
//     children: [
//       {
//         label: 'Events',
//         children: [
//           { label: 'Annual Meet', link: '#' },
//           { label: 'Leadership Camp', link: '#' },
//         ],
//       },
//       {
//         label: 'Resources',
//         children: [
//           { label: 'Downloads', link: '#' },
//           { label: 'Presentations', link: '#' },
//         ],
//       },
//     ],
//   },
// ];

// export default function AppNavbar() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const renderMenu = (items) => (
//     <ul className="menu">
//       {items.map((item, index) => (
//         <li key={index} className={item.children ? 'has-sub' : ''}>
//           <a href={item.link || '#'}>{item.label}</a>
//           {item.children && (
//             <div className="dropdown">
//               <span className="dropdown-arrow" />
//               {renderMenu(item.children)}
//             </div>
//           )}
//         </li>
//       ))}
//     </ul>
//   );

//   return (
//     <header className="nav-header">
//       <div className="nav-container">
//         <a href="/" className="nav-logo">
//           <img src={logo} alt="Logo" />
//         </a>
//         <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>
//           <span /><span /><span />
//         </button>
//         <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
//           {renderMenu(menuItems)}
//         </nav>
//       </div>
//     </header>
//   );
// }

// import React, { useState } from 'react';
// import Dropdown from './Dropdown';
// import './Navbar.css';

// const Navbar = () => {
//   const [dropdown, setDropdown] = useState('');

//   return (
//     <nav className="navbar">
//       <div className="logo">Lions International</div>
//       <ul className="nav-links">
//         <li
//           onMouseEnter={() => setDropdown('about')}
//           onMouseLeave={() => setDropdown('')}
//         >
//           About Us
//           {dropdown === 'about' && (
//             <Dropdown
//               sections={{
//                 'Our Organization': ['About Lions International', 'Our History', 'Our Leaders'],
//                 'Our Membership': ['Member Benefits', 'Membership and Club Types'],
//                 'Our Foundation': ['About Our Foundation', 'Transparency and Financial Stewardship', 'Foundation Annual Report', 'Ways to Give', 'Foundation Leaders'],
//                 'News & Media': ['Press Center', 'Social Media'],
//               }}
//             />
//           )}
//         </li>
//         <li>Our Impact</li>
//         <li>Get Involved</li>
//         <li className="join-btn">Join</li>
//         <li className="donate-btn">Donate</li>
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;
// import React from 'react';
// import './Navbar.css';

// const Navbar = () => {
//   return (
//     <div className="navbar-container">
//       <div className="navbar-logo">
//         <img src="/logo.png" alt="Lions Logo" />
//         <span>Lions International</span>
//       </div>
//       <ul className="navbar-links">
//         <li className="dropdown">
//           <span>About Us</span>
//           <div className="dropdown-content">
//             <div>
//               <h4>Our Organization</h4>
//               <p>About Lions International</p>
//               <p>Our History</p>
//               <p>Our Leaders</p>
//             </div>
//             <div>
//               <h4>Our Membership</h4>
//               <p>Member Benefits</p>
//               <p>Membership and Club Types</p>
//             </div>
//             <div>
//               <h4>Our Foundation</h4>
//               <p>About Our Foundation</p>
//               <p>Transparency and Financial Stewardship</p>
//               <p>Foundation Annual Report</p>
//               <p>Ways to Give</p>
//               <p>Foundation Leaders</p>
//             </div>
//             <div>
//               <h4>News & Media</h4>
//               <p>Press Center</p>
//               <p>Social Media</p>
//             </div>
//           </div>
//         </li>
//         <li><span>Our Impact</span></li>
//         <li><span>Get Involved</span></li>
//         <li><a className="resource-link" href="#">Member Resource Center</a></li>
//       </ul>
//       <div className="navbar-actions">
//         <button className="join-btn">Join</button>
//         <button className="donate-btn">Donate</button>
//         <input type="text" placeholder="🔍" className="search-icon" />
//       </div>
//     </div>
//   );
// };

// export default Navbar;


// import React, { useEffect, useState } from "react";
// import "./Navbar.css";
// import { FaHome } from "react-icons/fa";
// import logo from './logo.png'
// import logo1 from '../images/logo.png'
// import { Link } from "react-router-dom";
// import axios from "axios";


// const Navbar = () => {
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
//   const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
//   const [isDropdownOpen3, setIsDropdownOpen3] = useState(false);
//   const [isDropdownOpen4, setIsDropdownOpen4] = useState(false);
//   const [isDropdownOpen5, setIsDropdownOpen5] = useState(false);
//   const [isDropdownOpen6, setIsDropdownOpen6] = useState(false);
//   const [isDropdownOpen7, setIsDropdownOpen7] = useState(false);
//   const [isDropdownOpen8, setIsDropdownOpen8] = useState(false);
//   const [isDropdownOpen9, setIsDropdownOpen9] = useState(false);
//   const [isDropdownOpen10, setIsDropdownOpen10] = useState(false);
//   const [isDropdownOpen11, setIsDropdownOpen11] = useState(false);

//   const [menuOpen, setMenuOpen] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);

//   const toggleDropdown = (name) => {
//     setActiveDropdown(activeDropdown === name ? null : name);
//   };

//   const [activeDropdown1, setActiveDropdown1] = useState(null);

//   const toggleDropdown1 = (name) => {
//     setActiveDropdown1(activeDropdown === name ? null : name);
//   };


//     const [menus, setMenus] = useState([]);

//   useEffect(() => {
//     axios.get("https://lcoiapi.emedha.in/appi/menus")
//       .then(res => {
//         setMenus(res.data);
//       })
//       .catch(err => {
//         console.error("Failed to fetch menus", err);
//       });
//   }, []);
//   return (
//     <>
//       {/* Top Alert */}
//       <div className="top-bar">
//         View the <a href="#">Official Call</a> and <a href="#">Notice of Amendments</a> to be voted on by the Delegates at the 2025 International Convention in Orlando.
//       </div>

//       {/* Middle Header */}
//       {/* <div className="middle-header ">

//         <div className="header-links text-right">
//           {/* <span>LION AI ✨</span> *
//           <span>LCIF</span>
//           <span>LION PORTAL</span>
//           <span>SHOP</span>
//           <span>CONVENTION</span>
//           <span>FIND A CLUB</span>
//           <span>EN </span>
//         </div>

//       </div> */}

//       <div className="middle-header1">
//         <div className="logo">
//           <img src={logo} alt="logo" className="glow-logo" style={{ height: '70px', width: '80px' }} />
//           <span style={{ color: 'white' }}>Lions International</span>
//         </div>

//         <div className="header-buttons">
//           {/* <button className="join">Join</button> */}
//           <button className="donate">Donate</button>
//           {/* <span className="search">🔍</span> */}
//           <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
//             ☰
//           </button>
//         </div>

//       </div>

//       {/* Main Navbar */}
//       <div className="main-navbar">
//         <ul className="menu">
//           <li> <a href="/"><FaHome style={{ fontSize: '30px' }} /></a></li>
//   {/* {menus.map((menu, index) => (
//     <li
//       className="dropdown"
//       key={menu.id}
//       onMouseEnter={() => setActiveDropdown(index)}
//       onMouseLeave={() => setActiveDropdown(null)}
//     >
//       <span style={{ color: '#005399' }}>{menu.name}</span>
//       {activeDropdown === index && menu.submenus.length > 0 && (
//         <div className="dropdown-content">
//           <div className="column">
//             {menu.submenus.map(sub => (
//               <p key={sub.id}>{sub.name}</p>
//             ))}
//           </div>
//         </div>
//       )}
//     </li>
//   ))} */}
//     {menus.map(menu => (
//         <li
//           key={menu.id}
//           className="dropdown"
//           onMouseEnter={() => setIsDropdownOpen(true)}
//           onMouseLeave={() => setIsDropdownOpen(false)}
//         >
//           <span style={{ color: '#005399' }}>{menu.name}</span>
//           {isDropdownOpen && (
//             <div className="dropdown-content">
//               <div className="column">

//                 {menu.submenus.map(submenu => (
//                   submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
//                     <div className="nested-dropdown" key={submenu.id}>
//                       <p className="has-submenu">{submenu.name} ▸</p>
//                       <div className="side-dropdown">
//                         {submenu.subPlusMenus.map(subPlus => (
//                           <Link key={subPlus.id} to={`/${subPlus.name.replace(/\s+/g, '')}`}>
//                             <p>{subPlus.name}</p>
//                           </Link>
//                         ))}
//                       </div>
//                     </div>
//                   ) : (
//                     <Link key={submenu.id} to={`/${submenu.name.replace(/\s+/g, '')}`}>
//                       <p>{submenu.name}</p>
//                     </Link>
//                   )
//                 ))}

//               </div>
//             </div>
//           )}
//         </li>
//       ))}

//           {/* <li
//             className="dropdown"
//             onMouseEnter={() => setIsDropdownOpen(true)}
//             onMouseLeave={() => setIsDropdownOpen(false)}
//           >
//             <span style={{ color: '#005399' }}>Membership</span>
//             {isDropdownOpen && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   {/* <h5>Our Organization</h5> *
//                   {/* <p><a href= '/membership'>Membership</a></p>   *
//                   <Link to='/membership'> <p>Membership</p></Link>
//                   {/* <p>Resources</p> *
//                   <div className="nested-dropdown">
//                     <p className="has-submenu">Resources ▸</p>
//                     <div className="side-dropdown">
//                       <Link to='/typesofmembers'>  <p>Types of Members</p></Link>
//                        <Link to='/Startanewclub'> <p>Start a new club</p></Link>
//                   <Link to='/StartaLeoclub'>  <p>Start a Leo Club</p></Link>  
//                        <Link to='/TypesofClub'> <p>Types of Clubs</p></Link>
//                       <Link to='/membershipgrant'><p>Membership Grants</p> </Link> 
//                       <Link to='/newMembershipform'> <p>New Member Form</p></Link>
//                       <Link to='/memberInductionCeremony'> <p>Member Induction Ceremony</p></Link>
//                       <Link to='/memberOrientation'> <p>New Member Orientation</p></Link>
//                       <Link to='/myLciLogintocheckdues'> <p>MyLCI Login to check dues</p></Link>
//                       <Link to='/payMembershipDues'> <p>Pay Membership Dues</p></Link>
//                       <Link to='/membershipAwards'> <p>Membership Awards</p></Link>
//                       <Link to='/leopAwards'> <p>Leo Awards</p></Link>
//                     </div>
//                   </div>

//               <Link to='/membershipHighlights'>      <p>Membership Highlights</p></Link>
//                 <Link to='/'>   <p>Women Membership</p></Link>
//                   <Link to='/'>  <p>Family Membership</p></Link>
//                 </div>


//               </div>
//             )}
//           </li>
//           <li className="dropdown"
//             onMouseEnter={() => setIsDropdownOpen1(true)}
//             onMouseLeave={() => setIsDropdownOpen1(false)}
//           ><span style={{ color: '#005399' }}>Magazine</span>
//             {isDropdownOpen1 && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   <p>Digital Magazine</p>
//                   <p>Flipbook Magazine</p>
//                   <p>Hindi Magazine</p>
//                 </div>
//               </div>
//             )}



//           </li>
//           <li className="dropdown"
//             onMouseEnter={() => setIsDropdownOpen2(true)}
//             onMouseLeave={() => setIsDropdownOpen2(false)}
//           ><span style={{ color: '#005399' }}>Leadership</span>
//             {isDropdownOpen2 && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   {/* <p>Leadership Events</p> *
//                   <div className="nested-dropdown">
//                     <p className="has-submenu">Leadership Events ▸</p>
//                     <div className="side-dropdown">
//                       <p>All India of DGE Teams</p>
//                       <p>LCI Institutes by MDs</p>
//                       <p>District Training</p>
//                     </div>
//                   </div>
//                   <div className="nested-dropdown">
//                     <p className="has-submenu">Resources</p>
//                     <div className="side-dropdown">
//                       <p>LCIP List</p>
//                       <p>LCI Institutes by MDs</p>

//                     </div>

//                   </div>
//                   <p>Presentations</p>
//                   <p>Leadership</p>
//                   <p>Leadership Team</p>
//                 </div>
//               </div>
//             )}</li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen3(true)} onMouseLeave={() => setIsDropdownOpen3(false)}>
//             <span style={{ color: '#005399' }}>Marketing</span>
//             {isDropdownOpen3 && (
//               <div className="dropdown-content">
//                 <div className="column">

//                   <p>Marketing</p>
//                   <p>Brand  Guidelines</p>
//                   <p>International Theame</p>
//                   <p>Marketing Awards</p>
//                   <p>Social Media Kits</p>
//                   <p>Social Media Checklist</p>
//                   <p>Social Media Guidelines for Clubs</p>
//                   <p>Social Media Pages</p>
//                   <p>Club Marketing Chairperson Pages</p>
//                   <p>The Lions International Marketing Awards Pages</p>
//                   <p>Interactive Club Marketing Guide</p>
//                   <p>Logos and Brand</p>
//                   <p>Lions Press Center</p>
//                   <p>LCI Video Center </p>
//                   <p>Lions Blog</p>
//                   {/* <p> </p> *

//                   <div className="nested-dropdown">
//                     <p className="has-submenu"> Lions Magazine ▸</p>
//                     <div className="side-dropdown">
//                       <p> Lions Magazine International</p>
//                       <p>Lion India Magazine </p>

//                     </div>
//                   </div>
//                   <p></p>

//                 </div></div>

//             )}

//           </li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen4(true)} onMouseLeave={() => setIsDropdownOpen4(false)}>
//             <span style={{ color: '#005399' }}>LCIF</span>
//             {isDropdownOpen4 && (
//               <div className="dropdown-content">
//                 <div className="column">

//                   <div className="nested-dropdown">
//                     <p className="has-submenu"> Grants ▸</p>
//                     <div className="side-dropdown">

//                       <p>  Grants</p>
//                       <p>SightFirst Grants</p>
//                       <p>Matching Grants</p>
//                       <p> Diabetes Grants</p>
//                       <p>Disaster Relief Grants</p>
//                       <p>Lions Quest Grants</p>
//                       <p>Designated Grants</p>
//                       <p>Leo Grants</p>
//                       <p>District and Club Community Impact Grants</p>
//                       <p>The Humanitarian Award</p>
//                       <p>Hunger Grant</p>
//                       <p>Childhood Cancer Grant</p>
//                       <p>Guide to Promoting a LCIF Grant Project</p>
//                       <p>10 Tips to Manage Your LCIF Grant</p>
//                       <p>LCIF Grants specific to India</p>

//                     </div>
//                   </div>


//                   <div className="nested-dropdown">
//                     <p className="has-submenu"> LCIF Causes Flyer India ▸</p>
//                     <div className="side-dropdown">
//                       <p> Hunger Causes Flyer India</p>

//                       <p>District Relief Causes Flyer India</p>

//                       <p> Childhood Causes Flyer India</p>

//                       <p> Youth Causes Flyer India</p>

//                       <p>Vision Causes Flyer India</p>

//                       <p>Environment Cause Flyer, India</p>
//                     </div>
//                   </div>

//                   <p>MJF Form</p>

//                   <div className="nested-dropdown">
//                     <p className="has-submenu"> Lions Quest ▸</p>
//                     <div className="side-dropdown">

//                       <p>About Lions Quest</p>
//                       <p>Lions Quest in India</p>
//                     </div>
//                   </div>
//                   <p>LCIF India Donation Pages</p>
//                   <p>LCIF Awards</p>
//                   <p></p>
//                 </div></div>
//             )}
//           </li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen5(true)} onMouseLeave={() => setIsDropdownOpen5(false)}>
//             <span style={{ color: '#005399' }}>CSR</span>
//             {isDropdownOpen5 && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   <p>CSR</p>
//                   <p>Advocacy</p>
//                   {/* <p></p> *
//                 </div></div>
//             )}
//           </li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen6(true)} onMouseLeave={() => setIsDropdownOpen6(false)}>
//             <span style={{ color: '#005399' }}> LEO</span>
//             {isDropdownOpen6 && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   <p> LEO </p>
//                   <p>  An inspiring history</p>
//                   <p>  The Leo motto</p>
//                   <p>  What is a "Leo Club"?</p>
//                   <p>  Who is a "Leo"?</p>
//                   <p>   What is "LEO"?</p>
//                   <p> Leo Grants</p>
//                   <p>  About Leos</p>
//                   <p> Leo-Lion Program</p>
//                   <p>  Start a Leo Club</p>
//                   <p>  Leo Awards and Recognitions</p>
//                   <p>  Leo Club Advisor Training</p>
//                   <p>  Leo Leadership Opportunities</p>
//                   <p>  Leo Club Advisors</p>
//                   <p> Show your Leo Pride</p>
//                   <p> Leo Club Leadership</p>


//                 </div></div>
//             )}

//           </li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen7(true)} onMouseLeave={() => setIsDropdownOpen7(false)}>
//             <a href="#">Club Support</a>
//             {isDropdownOpen7 && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   <p> Managing a Club </p>
//                   <p>   Managing a District</p>
//                   <p>    Name Badges</p>
//                   <p> Start a new club</p>
//                   <p>   Global Action Team</p>
//                   <p>   New Voices</p>
//                 </div></div>
//             )}

//           </li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen8(true)} onMouseLeave={() => setIsDropdownOpen8(false)}>
//             <a href="#">Service</a>
//             {isDropdownOpen8 && (
//               <div className="dropdown-content">
//                 <div className="column">

//                   <p>  Service</p>
//                   <div className="nested-dropdown">
//                     <p className="has-submenu"> LCI Causes ▸</p>
//                     <div className="side-dropdown">
//                       <p>Diabetes  </p>
//                       <p>Vision</p>
//                       <p>Hunger</p>
//                       <p>Environment</p>
//                       <p>Childhood Cancer</p>
//                       <p>Humanitarian</p>

//                     </div>
//                   </div>

//                   <div className="nested-dropdown">
//                     <p className="has-submenu"> Service Activities in India ▸</p>
//                     <div className="side-dropdown">
//                       <p> Diabetes</p>
//                       <p>  Vision</p>
//                       <p>  Hunger</p>
//                       <p>  Environment</p>
//                       <p>  Childhood Cancer</p>
//                       <p>  Education</p>
//                       <p>  Disaster Relief</p>
//                       <p>  Health</p>
//                       <p>  Others</p>
//                     </div>
//                   </div>



//                 </div></div>
//             )}

//           </li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen9(true)} onMouseLeave={() => setIsDropdownOpen9(false)}>
//             <a href="#">Events</a>
//             {isDropdownOpen9 && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   <p>  GAT Conclave 2022  </p>
//                   <p>ISAME Forum 2022</p>
//                   <p>ISAME Forum 2023</p>
//                   <p>ISAME Forum 2024</p>
//                   <p>All india schooling</p>
//                   <p>E-waste</p>
//                   <p>Initiatives</p>
//                 </div></div>
//             )}

//           </li>
//           <li className="dropdown" onMouseEnter={() => setIsDropdownOpen10(true)} onMouseLeave={() => setIsDropdownOpen10(false)}>
//             <a href="#">Lions History</a>
//             {isDropdownOpen10 && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   <p>LCI About Us</p>
//                   <p>LCI Mission and History</p>
//                   <p>  LCIF Mission</p>
//                   <p> LCIF History</p>

//                 </div></div>
//             )}

//           </li>
// <li className="dropdown" onMouseEnter={() => setIsDropdownOpen11(true)} onMouseLeave={() => setIsDropdownOpen11(false)}>
//   <a href="#">Directory</a>
//   {isDropdownOpen11 && (
//     <div className="dropdown-content">
//       <div className="column">
//         <p>Lion Leaders of India 2024-2025</p>

//       </div></div>
//   )}

// </li> 
// */}
//         </ul>
//       </div>

//       {menuOpen && (
//         <div className={`mobile-sidebar ${menuOpen ? 'open' : ''}`}>
//           <button className="close-btn" onClick={() => setMenuOpen(false)}>×</button>
//           <ul className="mobile-menu">
//             <li><a href="/"><FaHome /></a></li>
//             <li onClick={() => toggleDropdown('membership')}>
//               Membership
//               {activeDropdown === 'membership' && (
//                 <div className="mobile-submenu">
//                   <p>Membership</p>
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('resources')}>
//                       Resources ▸
//                     </p>
//                     {activeDropdown1 === 'resources' && (
//                       <div className="mobile-side-submenu">
//                         <p>Types of Members</p>
//                         <p>Start a new club</p>
//                         <p>Start a Leo Club</p>
//                         <p>Types of Clubs</p>
//                         <p>Membership Grants</p>
//                         <p>New Member Form</p>
//                         <p>Member Induction Ceremony</p>
//                         <p>New Member Orientation</p>
//                         <p>MyLCI Login to check dues</p>
//                         <p>Pay Membership Dues</p>
//                         <p>Membership Awards</p>
//                         <p>Leo Awards</p>
//                       </div>
//                     )}
//                   </div>
//                   <p>Membership Highlights</p>
//                   <p>Women Membership</p>
//                   <p>Family Membership</p>
//                 </div>
//               )}
//             </li>
//             <li onClick={() => toggleDropdown('Magazine')}
//             >Magazine
//               {activeDropdown === 'Magazine' && (
//                 <div className="mobile-submenu">
//                   <p>Digital Magazine</p>
//                   <p>Flipbook Magazine</p>
//                   <p>Hindi Magazine</p>
//                 </div>

//               )}</li>
//             <li onClick={() => toggleDropdown('Leadership')} >Leadership
//               {activeDropdown === 'Leadership' && (
//                 <div className="mobile-submenu">
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('resources')}>
//                       Leadership Events  ▸
//                     </p>
//                     {activeDropdown1 === 'resources' && (
//                       <div className="mobile-side-submenu">
//                         <p>All India of DGE Teams</p>
//                         <p>LCI Institutes by MDs</p>
//                         <p>District Training</p>
//                       </div>
//                     )}
//                   </div>
//                   <p>Resources</p>
//                   <p>Presentations</p>
//                   <p>Leadership</p>
//                   <p>Leadership Team</p>

//                 </div>
//               )}
//             </li>

//             <li onClick={() => toggleDropdown('Marketing')}
//             >Marketing
//               {activeDropdown === 'Marketing' && (
//                 <div className="mobile-submenu">
//                   <p>Marketing</p>
//                   <p>Brand  Guidelines</p>
//                   <p>International Theame</p>
//                   <p>Marketing Awards</p>
//                   <p>Social Media Kits</p>
//                   <p>Social Media Checklist</p>
//                   <p>Social Media Guidelines for Clubs</p>
//                   <p>Social Media Pages</p>
//                   <p>Club Marketing Chairperson Pages</p>
//                   <p>The Lions International Marketing Awards Pages</p>
//                   <p>Interactive Club Marketing Guide</p>
//                   <p>Logos and Brand</p>
//                   <p>Lions Press Center</p>
//                   <p>LCI Video Center </p>
//                   <p>Lions Blog</p>

//                   <div className="mobile-submenu">
//                     <div className="nested-dropdown">
//                       <p onClick={() => toggleDropdown1('Lions Magazine')}>
//                         Lions Magazine  ▸
//                       </p>
//                       {activeDropdown1 === 'Lions Magazine' && (
//                         <div className="mobile-side-submenu">
//                           <p> Lions Magazine International</p>
//                           <p>Lion India Magazine </p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//               )}</li>

//             <li onClick={() => toggleDropdown('LCIF')}
//             >LCIF
//               {activeDropdown === 'LCIF' && (
//                 <div className="mobile-submenu">
//                   <p>MJF Form</p>
//                   <p>LCIF India Donation Pages</p>
//                   <p>LCIF Awards</p>


//                   <div className="mobile-submenu">
//                     <div className="nested-dropdown">
//                       <p onClick={() => toggleDropdown1('Grants')}>
//                         Grants  ▸
//                       </p>
//                       {activeDropdown1 === 'Grants' && (
//                         <div className="mobile-side-submenu">
//                           <p>  Grants</p>
//                           <p>SightFirst Grants</p>
//                           <p>Matching Grants</p>
//                           <p> Diabetes Grants</p>
//                           <p>Disaster Relief Grants</p>
//                           <p>Lions Quest Grants</p>
//                           <p>Designated Grants</p>
//                           <p>Leo Grants</p>
//                           <p>District and Club Community Impact Grants</p>
//                           <p>The Humanitarian Award</p>
//                           <p>Hunger Grant</p>
//                           <p>Childhood Cancer Grant</p>
//                           <p>Guide to Promoting a LCIF Grant Project</p>
//                           <p>10 Tips to Manage Your LCIF Grant</p>
//                           <p>LCIF Grants specific to India</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="mobile-submenu">
//                     <div className="nested-dropdown">
//                       <p onClick={() => toggleDropdown1('LCIF Causes Flyer India')}>
//                         LCIF Causes Flyer India  ▸
//                       </p>
//                       {activeDropdown1 === 'LCIF Causes Flyer India' && (
//                         <div className="mobile-side-submenu">
//                           <p> Hunger Causes Flyer India</p>

//                           <p>District Relief Causes Flyer India</p>

//                           <p> Childhood Causes Flyer India</p>

//                           <p> Youth Causes Flyer India</p>

//                           <p>Vision Causes Flyer India</p>

//                           <p>Environment Cause Flyer, India</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="mobile-submenu">
//                     <div className="nested-dropdown">
//                       <p onClick={() => toggleDropdown1('Lions Quest ')}>
//                         Lions Quest ▸
//                       </p>
//                       {activeDropdown1 === 'Lions Quest ' && (
//                         <div className="mobile-side-submenu">
//                           <p>About Lions Quest</p>
//                           <p>Lions Quest in India</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//               )}</li>
//             <li onClick={() => toggleDropdown('CSR')}
//             >CSR
//               {activeDropdown === 'CSR' && (
//                 <div className="mobile-submenu">
//                   <p>CSR</p>
//                   <p>Advocacy</p>


//                 </div>

//               )}</li>

//             <li onClick={() => toggleDropdown('LEO')}
//             >LEO
//               {activeDropdown === 'LEO' && (
//                 <div className="mobile-submenu">
//                   <p> LEO </p>
//                   <p>  An inspiring history</p>
//                   <p>  The Leo motto</p>
//                   <p>  What is a "Leo Club"?</p>
//                   <p>  Who is a "Leo"?</p>
//                   <p>   What is "LEO"?</p>
//                   <p> Leo Grants</p>
//                   <p>  About Leos</p>
//                   <p> Leo-Lion Program</p>
//                   <p>  Start a Leo Club</p>
//                   <p>  Leo Awards and Recognitions</p>
//                   <p>  Leo Club Advisor Training</p>
//                   <p>  Leo Leadership Opportunities</p>
//                   <p>  Leo Club Advisors</p>
//                   <p> Show your Leo Pride</p>
//                   <p> Leo Club Leadership</p>



//                 </div>

//               )}</li>

//             <li onClick={() => toggleDropdown('Club Support')}
//             >Club Support
//               {activeDropdown === 'Club Support' && (
//                 <div className="mobile-submenu">
//                   <p> Managing a Club </p>
//                   <p>   Managing a District</p>
//                   <p>    Name Badges</p>
//                   <p> Start a new club</p>
//                   <p>   Global Action Team</p>
//                   <p>   New Voices</p>


//                 </div>

//               )}</li>

//             <li onClick={() => toggleDropdown('Service')}
//             >Service
//               {activeDropdown === 'Service' && (
//                 <div className="mobile-submenu">
//                   <p>  Service</p>



//                   <div className="mobile-submenu">
//                     <div className="nested-dropdown">
//                       <p onClick={() => toggleDropdown1('LCI Causes')}>
//                         LCI Causes ▸
//                       </p>
//                       {activeDropdown1 === 'LCI Causes' && (
//                         <div className="mobile-side-submenu">
//                           <p>Diabetes  </p>
//                           <p>Vision</p>
//                           <p>Hunger</p>
//                           <p>Environment</p>
//                           <p>Childhood Cancer</p>
//                           <p>Humanitarian</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="mobile-submenu">
//                     <div className="nested-dropdown">
//                       <p onClick={() => toggleDropdown1('Service Activities in India')}>
//                         ServiceActivities in India
//                       </p>
//                       {activeDropdown1 === 'Service Activities in India' && (
//                         <div className="mobile-side-submenu">
//                           <p> Diabetes</p>
//                           <p>  Vision</p>
//                           <p>  Hunger</p>
//                           <p>  Environment</p>
//                           <p>  Childhood Cancer</p>
//                           <p>  Education</p>
//                           <p>  Disaster Relief</p>
//                           <p>  Health</p>
//                           <p>  Others</p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//               )}</li>

//             <li onClick={() => toggleDropdown('Events')}
//             >Events
//               {activeDropdown === 'Events' && (
//                 <div className="mobile-submenu">
//                   <p>  GAT Conclave 2022  </p>
//                   <p>ISAME Forum 2022</p>
//                   <p>ISAME Forum 2023</p>
//                   <p>ISAME Forum 2024</p>
//                   <p>All india schooling</p>
//                   <p>E-waste</p>
//                   <p>Initiatives</p>


//                 </div>

//               )}</li>
//             <li onClick={() => toggleDropdown('Lions History')}
//             >Lions History
//               {activeDropdown === 'Lions History' && (
//                 <div className="mobile-submenu">
//                   <p>LCI About Us</p>
//                   <p>LCI Mission and History</p>
//                   <p>  LCIF Mission</p>
//                   <p> LCIF History</p>


//                 </div>

//               )}</li>
// <li onClick={() => toggleDropdown('Directory')}
// >Directory
//   {activeDropdown === 'Directory' && (
//     <div className="mobile-submenu">
//       <p>Lion Leaders of India 2024-2025</p>
//     </div>

//   )}</li>


//           </ul>
//         </div>
//       )}
//     </>
//   );
// };

// export default Navbar;

// {/* <li onClick={() => toggleDropdown('membership')}>
//             Membership
//             {activeDropdown === 'membership' && (
//               <div className="mobile-submenu">
//                 <p>Membership</p>
//                 <div className="nested-dropdown">
//                   <p onClick={() => toggleDropdown1('resources')}>
//                     Resources ▸
//                   </p>
//                   {activeDropdown1 === 'resources' && (
//                     <div className="mobile-side-submenu">
//                       <p>Types of Members</p>
//                       <p>Start a new club</p>
//                       <p>Start a Leo Club</p>
//                       <p>Types of Clubs</p>
//                       <p>Membership Grants</p>
//                       <p>New Member Form</p>
//                       <p>Member Induction Ceremony</p>
//                       <p>New Member Orientation</p>
//                       <p>MyLCI Login to check dues</p>
//                       <p>Pay Membership Dues</p>
//                       <p>Membership Awards</p>
//                       <p>Leo Awards</p>
//                     </div>
//                   )}
//                 </div>
//                 <p>Membership Highlights</p>
//                 <p>Women Membership</p>
//                 <p>Family Membership</p>
//               </div>
//             )}
//           </li>
//           <li onClick={() => toggleDropdown('Magazine')}
//           >Magazine
//             {activeDropdown === 'Magazine' && (
//               <div className="mobile-submenu">
//                 <p>Digital Magazine</p>
//                 <p>Flipbook Magazine</p>
//                 <p>Hindi Magazine</p>
//               </div>

//             )}</li>
//           <li onClick={() => toggleDropdown('Leadership')} >Leadership
//             {activeDropdown === 'Leadership' && (
//               <div className="mobile-submenu">
//                 <div className="nested-dropdown">
//                   <p onClick={() => toggleDropdown1('resources')}>
//                     Leadership Events  ▸
//                   </p>
//                   {activeDropdown1 === 'resources' && (
//                     <div className="mobile-side-submenu">
//                       <p>All India of DGE Teams</p>
//                       <p>LCI Institutes by MDs</p>
//                       <p>District Training</p>
//                     </div>
//                   )}
//                 </div>
//                 <p>Resources</p>
//                 <p>Presentations</p>
//                 <p>Leadership</p>
//                 <p>Leadership Team</p>

//               </div>
//             )}
//           </li>

//           <li onClick={() => toggleDropdown('Marketing')}
//           >Marketing
//             {activeDropdown === 'Marketing' && (
//               <div className="mobile-submenu">
//                 <p>Marketing</p>
//                 <p>Brand  Guidelines</p>
//                 <p>International Theame</p>
//                 <p>Marketing Awards</p>
//                 <p>Social Media Kits</p>
//                 <p>Social Media Checklist</p>
//                 <p>Social Media Guidelines for Clubs</p>
//                 <p>Social Media Pages</p>
//                 <p>Club Marketing Chairperson Pages</p>
//                 <p>The Lions International Marketing Awards Pages</p>
//                 <p>Interactive Club Marketing Guide</p>
//                 <p>Logos and Brand</p>
//                 <p>Lions Press Center</p>
//                 <p>LCI Video Center </p>
//                 <p>Lions Blog</p>

//                 <div className="mobile-submenu">
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('Lions Magazine')}>
//                       Lions Magazine  ▸
//                     </p>
//                     {activeDropdown1 === 'Lions Magazine' && (
//                       <div className="mobile-side-submenu">
//                         <p> Lions Magazine International</p>
//                         <p>Lion India Magazine </p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//             )}</li>

//           <li onClick={() => toggleDropdown('LCIF')}
//           >LCIF
//             {activeDropdown === 'LCIF' && (
//               <div className="mobile-submenu">
//                 <p>MJF Form</p>
//                 <p>LCIF India Donation Pages</p>
//                 <p>LCIF Awards</p>


//                 <div className="mobile-submenu">
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('Grants')}>
//                       Grants  ▸
//                     </p>
//                     {activeDropdown1 === 'Grants' && (
//                       <div className="mobile-side-submenu">
//                         <p>  Grants</p>
//                         <p>SightFirst Grants</p>
//                         <p>Matching Grants</p>
//                         <p> Diabetes Grants</p>
//                         <p>Disaster Relief Grants</p>
//                         <p>Lions Quest Grants</p>
//                         <p>Designated Grants</p>
//                         <p>Leo Grants</p>
//                         <p>District and Club Community Impact Grants</p>
//                         <p>The Humanitarian Award</p>
//                         <p>Hunger Grant</p>
//                         <p>Childhood Cancer Grant</p>
//                         <p>Guide to Promoting a LCIF Grant Project</p>
//                         <p>10 Tips to Manage Your LCIF Grant</p>
//                         <p>LCIF Grants specific to India</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <div className="mobile-submenu">
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('LCIF Causes Flyer India')}>
//                       LCIF Causes Flyer India  ▸
//                     </p>
//                     {activeDropdown1 === 'LCIF Causes Flyer India' && (
//                       <div className="mobile-side-submenu">
//                         <p> Hunger Causes Flyer India</p>

//                         <p>District Relief Causes Flyer India</p>

//                         <p> Childhood Causes Flyer India</p>

//                         <p> Youth Causes Flyer India</p>

//                         <p>Vision Causes Flyer India</p>

//                         <p>Environment Cause Flyer, India</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <div className="mobile-submenu">
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('Lions Quest ')}>
//                       Lions Quest ▸
//                     </p>
//                     {activeDropdown1 === 'Lions Quest ' && (
//                       <div className="mobile-side-submenu">
//                         <p>About Lions Quest</p>
//                         <p>Lions Quest in India</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//             )}</li>
//           <li onClick={() => toggleDropdown('CSR')}
//           >CSR
//             {activeDropdown === 'CSR' && (
//               <div className="mobile-submenu">
//                 <p>CSR</p>
//                 <p>Advocacy</p>


//               </div>

//             )}</li>

//           <li onClick={() => toggleDropdown('LEO')}
//           >LEO
//             {activeDropdown === 'LEO' && (
//               <div className="mobile-submenu">
//                 <p> LEO </p>
//                 <p>  An inspiring history</p>
//                 <p>  The Leo motto</p>
//                 <p>  What is a "Leo Club"?</p>
//                 <p>  Who is a "Leo"?</p>
//                 <p>   What is "LEO"?</p>
//                 <p> Leo Grants</p>
//                 <p>  About Leos</p>
//                 <p> Leo-Lion Program</p>
//                 <p>  Start a Leo Club</p>
//                 <p>  Leo Awards and Recognitions</p>
//                 <p>  Leo Club Advisor Training</p>
//                 <p>  Leo Leadership Opportunities</p>
//                 <p>  Leo Club Advisors</p>
//                 <p> Show your Leo Pride</p>
//                 <p> Leo Club Leadership</p>



//               </div>

//             )}</li>

//           <li onClick={() => toggleDropdown('Club Support')}
//           >Club Support
//             {activeDropdown === 'Club Support' && (
//               <div className="mobile-submenu">
//                 <p> Managing a Club </p>
//                 <p>   Managing a District</p>
//                 <p>    Name Badges</p>
//                 <p> Start a new club</p>
//                 <p>   Global Action Team</p>
//                 <p>   New Voices</p>


//               </div>

//             )}</li>

//           <li onClick={() => toggleDropdown('Service')}
//           >Service
//             {activeDropdown === 'Service' && (
//               <div className="mobile-submenu">
//                 <p>  Service</p>



//                 <div className="mobile-submenu">
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('LCI Causes')}>
//                       LCI Causes ▸
//                     </p>
//                     {activeDropdown1 === 'LCI Causes' && (
//                       <div className="mobile-side-submenu">
//                         <p>Diabetes  </p>
//                         <p>Vision</p>
//                         <p>Hunger</p>
//                         <p>Environment</p>
//                         <p>Childhood Cancer</p>
//                         <p>Humanitarian</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <div className="mobile-submenu">
//                   <div className="nested-dropdown">
//                     <p onClick={() => toggleDropdown1('Service Activities in India')}>
//                       ServiceActivities in India
//                     </p>
//                     {activeDropdown1 === 'Service Activities in India' && (
//                       <div className="mobile-side-submenu">
//                         <p> Diabetes</p>
//                         <p>  Vision</p>
//                         <p>  Hunger</p>
//                         <p>  Environment</p>
//                         <p>  Childhood Cancer</p>
//                         <p>  Education</p>
//                         <p>  Disaster Relief</p>
//                         <p>  Health</p>
//                         <p>  Others</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//             )}</li>

//           <li onClick={() => toggleDropdown('Events')}
//           >Events
//             {activeDropdown === 'Events' && (
//               <div className="mobile-submenu">
//                 <p>  GAT Conclave 2022  </p>
//                 <p>ISAME Forum 2022</p>
//                 <p>ISAME Forum 2023</p>
//                 <p>ISAME Forum 2024</p>
//                 <p>All india schooling</p>
//                 <p>E-waste</p>
//                 <p>Initiatives</p>


//               </div>

//             )}</li>
//           <li onClick={() => toggleDropdown('Lions History')}
//           >Lions History
//             {activeDropdown === 'Lions History' && (
//               <div className="mobile-submenu">
//                 <p>LCI About Us</p>
//                 <p>LCI Mission and History</p>
//                 <p>  LCIF Mission</p>
//                 <p> LCIF History</p>


//               </div>

//             )}</li>
//           <li onClick={() => toggleDropdown('Directory')}
//           >Directory
//             {activeDropdown === 'Directory' && (
//               <div className="mobile-submenu">
//                 <p>Lion Leaders of India 2024-2025</p>
//               </div>

//             )}</li> */}

// import React, { useEffect, useState } from "react";
// import "./Navbar.css";
// import { FaHome } from "react-icons/fa";
// import logo from './logo.png'
// import logo1 from '../images/logo.png'
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Modal from "react-modal";
// import { TranslateClient, TranslateTextCommand } from "@aws-sdk/client-translate";



// // Bind modal to your app element
// Modal.setAppElement("#root");



// // 🔹 Create AWS Translate client
// const translateClient = new TranslateClient({
//   region: "ap-south-1",
//   credentials: {
//     accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
//     secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
//   },
// });

// const langMap = {
//   English: "en",
//   "हिन्दी (Hindi)": "hi",
//   "বাংলা (Bengali)": "bn",
//   "తెలుగు (Telugu)": "te",
//   "मराठी (Marathi)": "mr",
//   "தமிழ் (Tamil)": "ta",
//   "ગુજરાતી (Gujarati)": "gu",
//   "ಕನ್ನಡ (Kannada)": "kn",
//   "മലയാളം (Malayalam)": "ml",
//   "ਪੰਜਾਬੀ (Punjabi)": "pa",
//   "ଓଡ଼ିଆ (Odia)": "or",
//   "অসমীয়া (Assamese)": "as",
//   "उर्दू (Urdu)": "ur",
//   "संस्कृत (Sanskrit)": "sa",
//   Maithili: "mai",
//   Konkani: "kok",
// };

// // async function translateText(text, lang) {
// //   if (!text || lang === "English") return text;
// //   try {
// //     const res = await translateClient.send(
// //       new TranslateTextCommand({
// //         Text: text,
// //         SourceLanguageCode: "auto",
// //         TargetLanguageCode: langMap[lang] || "en",
// //       })
// //     );
// //     return res.TranslatedText;
// //   } catch (e) {
// //     console.error("Translate error:", e);
// //     return text;
// //   }
// // }

// // 🔹 Utility function to translate text

// export const translateText = async (text, targetLang) => {
//   try {
//     const command = new TranslateTextCommand({
//       Text: text,
//       SourceLanguageCode: "en",   // from English
//       TargetLanguageCode: targetLang, // to selected lang
//     });

//     const response = await translateClient.send(command);
//     return response.TranslatedText;
//   } catch (error) {
//     console.error("Translation error:", error);
//     return text;
//   }
// };






// const Navbar = ({ selectedLang, setSelectedLang }) => {
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);


//   const [menuOpen, setMenuOpen] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [activeDropdownd, setActiveDropdownd] = useState(null);
//   const [activeDropdowndM, setActiveDropdowndM] = useState(null);
//   const toggleDropdown = (name) => {
//     setActiveDropdown(activeDropdown === name ? null : name);
//   };

//   const [activeDropdown1, setActiveDropdown1] = useState(null);

//   const toggleDropdown1 = (name) => {
//     setActiveDropdown1(activeDropdown === name ? null : name);
//   };


//   const [menus, setMenus] = useState([]);

//   // useEffect(() => {
//   //   axios.get("https://lcoiapi.emedha.in/appi/menus")
//   //     .then(res => {
//   //       setMenus(res.data);
//   //     })
//   //     .catch(err => {
//   //       console.error("Failed to fetch menus", err);
//   //     });
//   // }, []);


//     // language 

//     const [isLangModalOpen, setIsLangModalOpen] = useState(false);
//   // const [selectedLang, setSelectedLang] = useState("English");
// console.log('this is Navbar selectedLang',selectedLang)

//     const indianLanguages = [
//     "English", "हिन्दी (Hindi)", "বাংলা (Bengali)", "తెలుగు (Telugu)", 
//     "मराठी (Marathi)", "தமிழ் (Tamil)", "ગુજરાતી (Gujarati)", "ಕನ್ನಡ (Kannada)", 
//     "മലയാളം (Malayalam)", "ਪੰਜਾਬੀ (Punjabi)", "ଓଡ଼ିଆ (Odia)", "অসমীয়া (Assamese)", 
//     "उर्दू (Urdu)", "संस्कृत (Sanskrit)", "Maithili", "Konkani"
//   ];

//   const handleLanguageSelect = (lang) => {
//     setSelectedLang(lang);
//     setIsLangModalOpen(false);
//     // 👉 You can also store in localStorage or call API to persist selection
//   };



//   useEffect(() => {
//     async function fetchMenus() {
//       try {
//         const res = await axios.get("https://lcoiapi.emedha.in/appi/menus");
//         let data = res.data;

//         if (selectedLang !== "English") {
//           data = await Promise.all(
//             data.map(async (menu) => ({
//               ...menu,
//               name: await translateText(menu.name, selectedLang),
//               submenus: await Promise.all(
//                 menu.submenus.map(async (sub) => ({
//                   ...sub,
//                   name: await translateText(sub.name, selectedLang),
//                   subPlusMenus: await Promise.all(
//                     sub.subPlusMenus.map(async (sp) => ({
//                       ...sp,
//                       name: await translateText(sp.name, selectedLang),
//                     }))
//                   ),
//                 }))
//               ),
//             }))
//           );
//         }

//         setMenus(data);
//       } catch (err) {
//         console.error("Failed to fetch menus", err);
//       }
//     }

//     fetchMenus();
//   }, [selectedLang]);



//   return (
//     <>
//       {/* Top Alert */}
//       <div className="top-bar">
//         {/* View the <a href="#">Official Call</a> and <a href="#">Notice of Amendments</a> to be voted on by the Delegates at the 2025 International Convention in Orlando. */}
//       </div>

//       {/* Middle Header */}
//       {/* <div className="middle-header ">

//         <div className="header-links text-right">
//           {/* <span>LION AI ✨</span> *
//           <span>LCIF</span>
//           <span>LION PORTAL</span> 
//           <span>SHOP</span>
//           <span>CONVENTION</span>
//           <span>FIND A CLUB</span>
//           <span>EN </span>
//         </div>

//       </div> */}

//       <div className="middle-header1">
//         <div className="logo">
//           <img src={logo} alt="logo" className="glow-logo" style={{ height: '70px', width: '80px' }} />
//           <span style={{ color: 'white' }}>Lions International</span>
//         </div>

//         <div className="header-buttons">
//           {/* <button className="join">Join</button> */}
//           <button className="donate">Donate</button>
//                {/* <button className="language-btn" onClick={() => setIsLangModalOpen(true)}>
//             {selectedLang} 🌐
//           </button> */}
//           {/* <span className="search">🔍</span> */}
//           <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
//             ☰
//           </button>
//         </div>

//       </div>
//         {/* Language Selection Modal */}
//         <Modal
//         isOpen={isLangModalOpen}
//         onRequestClose={() => setIsLangModalOpen(false)}
//         contentLabel="Select Language"
//         style={{
//           content: {
//             width: "300px",
//             height: "auto",
//             margin: "auto",
//             borderRadius: "12px",
//             padding: "20px",
//             textAlign: "center",
//             background: "#f9f9f9",
//             boxShadow: "0px 4px 12px rgba(0,0,0,0.2)"
//           },
//           overlay: {
//             backgroundColor: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center"
//           }
//         }}
//       >
//         <h3 style={{ marginBottom: "15px", color: "#005399" }}>Select Language</h3>

//         <div style={{ maxHeight: "500px", overflowY: "auto" }}>
//           {indianLanguages.map((lang, i) => (
//             <button 
//               key={i} 
//               onClick={() => handleLanguageSelect(lang)} 
//               style={{
//                 display: "block",
//                 width: "100%",
//                 padding: "8px",
//                 margin: "5px 0",
//                 border: "1px solid #ddd",
//                 borderRadius: "6px",
//                 background: selectedLang === lang ? "#005399" : "#fff",
//                 color: selectedLang === lang ? "#fff" : "#333",
//                 cursor: "pointer"
//               }}
//             >
//               {lang}
//             </button>
//           ))}
//         </div>

//         <button 
//           onClick={() => setIsLangModalOpen(false)} 
//           style={{
//             marginTop: "15px",
//             padding: "8px 16px",
//             background: "#999",
//             border: "none",
//             borderRadius: "6px",
//             color: "#fff",
//             cursor: "pointer"
//           }}
//         >
//           Close
//         </button>
//       </Modal>

//       {/* Main Navbar */}
//       <div className="main-navbar">
//         <ul className="menu">
//           <li> <a href="/"><FaHome style={{ fontSize: '30px' }} /></a></li>
//           {/* {menus.map((menu, index) => (
//     <li
//       className="dropdown"
//       key={menu.id}
//       onMouseEnter={() => setActiveDropdown(index)}
//       onMouseLeave={() => setActiveDropdown(null)}
//     >
//       <span style={{ color: '#005399' }}>{menu.name}</span>
//       {activeDropdown === index && menu.submenus.length > 0 && (
//         <div className="dropdown-content">
//           <div className="column">
//             {menu.submenus.map(sub => (
//               <p key={sub.id}>{sub.name}</p>
//             ))}
//           </div>
//         </div>
//       )}
//     </li>
//   ))} */}
//           {menus.map(menu => (
//             <li
//               key={menu.id}
//               className="dropdown"
//               // onMouseEnter={() => setIsDropdownOpen(true)}
//               // onMouseLeave={() => setIsDropdownOpen(false)}
//               onMouseEnter={() => setActiveDropdown(menu.id)}
//               onMouseLeave={() => setActiveDropdown(null)}

//             >
//               {/* <span style={{ color: '#005399' }}>   <Link to={`/content?menus_id=${menu.id}`}>{menu.name} </Link></span> */}
//               <span style={{ color: '#005399' }}>   {menu.name} </span>
//               {/* {isDropdownOpen && ( */}
//               {activeDropdown === menu.id && (

//                 <div className="dropdown-content">
//                   <div className="column">

//                     {menu.submenus.map(submenu => (
//                       submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
//                         <div className="nested-dropdown" key={submenu.id}>
//                           <p className="has-submenu"><Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>{submenu.name} ▸  </Link></p>
//                           <d v className="side-dropdown">
//                             {submenu.subPlusMenus.map(subPlus => (
//                               // <Link key={subPlus.id} to={`/${subPlus.name.replace(/\s+/g, '')}`}>
//                               <p>  <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}&sub_plus_menus_id=${subPlus.id}`}>{subPlus.name}   </Link></p>
//                               // </Link>
//                             ))}
//                           </d>
//                         </div>
//                       ) : (
//                         // <Link key={submenu.id} to={`/${submenu.name.replace(/\s+/g, '')}`}>
//                         <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
//                           <p>{submenu.name}</p>
//                         </Link>
//                       )
//                     ))}

//                   </div>
//                 </div>
//               )}
//             </li>
//           ))}
//           <li className="dropdown" 
//           // onMouseEnter={() => setIsDropdownOpen11(true)}
//           //  onMouseLeave={() => setIsDropdownOpen11(false)}>
//            onMouseEnter={() => setActiveDropdownd(true)}
//               onMouseLeave={() => setActiveDropdownd(false)}>

//             <a href="#">Directory</a>
//             {activeDropdownd && (
//               <div className="dropdown-content">
//                 <div className="column">
//                  <Link to='/leadersPage'> <p>Lion Leaders of India 2025-2026</p>
// </Link>
//                 </div></div>
//             )}

//           </li>
//           <li className="dropdown" 
//           // onMouseEnter={() => setIsDropdownOpen11(true)}
//           //  onMouseLeave={() => setIsDropdownOpen11(false)}>
//            onMouseEnter={() => setActiveDropdowndM(true)}
//               onMouseLeave={() => setActiveDropdowndM(false)}>

//             <a href="#">Magazine</a>
//             {activeDropdowndM && (
//               <div className="dropdown-content">
//                 <div className="column">
//                  <Link to='/Flipbook'> <p>Flip Book</p>
// </Link>
//                 </div></div>
//             )}

//           </li>
//         </ul>
//       </div>

//       {menuOpen && (
//         <div className={`mobile-sidebar ${menuOpen ? 'open' : ''}`}>
//           <button className="close-btn" onClick={() => setMenuOpen(false)}>×</button>
//           <ul className="mobile-menu">
//             <li><a href="/"><FaHome /></a></li>


//           {menus.map(menu => (
//             <li
//               key={menu.id}
//               className="dropdown"
//               // onMouseEnter={() => setIsDropdownOpen(true)}
//               // onMouseLeave={() => setIsDropdownOpen(false)}
//               onMouseEnter={() => setActiveDropdown(menu.id)}
//               onMouseLeave={() => setActiveDropdown(null)}

//             >
//               {/* <span style={{ color: '#005399' }}>   <Link to={`/content?menus_id=${menu.id}`}>{menu.name} </Link></span> */}
//               <span style={{ color: '#005399' }}>   {menu.name} </span>
//               {/* {isDropdownOpen && ( */}
//               {activeDropdown === menu.id && (

//                 <div className="dropdown-content">
//                   <div className="column">

//                     {menu.submenus.map(submenu => (
//                       submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
//                         <div className="nested-dropdown" key={submenu.id}>
//                           <p className="has-submenu"><Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>{submenu.name} ▸  </Link></p>
//                           <d v className="side-dropdown">
//                             {submenu.subPlusMenus.map(subPlus => (
//                               // <Link key={subPlus.id} to={`/${subPlus.name.replace(/\s+/g, '')}`}>
//                               <p>  <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}&sub_plus_menus_id=${subPlus.id}`}>{subPlus.name}   </Link></p>
//                               // </Link>
//                             ))}
//                           </d>
//                         </div>
//                       ) : (
//                         // <Link key={submenu.id} to={`/${submenu.name.replace(/\s+/g, '')}`}>
//                         <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
//                           <p>{submenu.name}</p>
//                         </Link>
//                       )
//                     ))}

//                   </div>
//                 </div>
//               )}
//             </li>
//           ))}
//           <li className="dropdown" 
//           // onMouseEnter={() => setIsDropdownOpen11(true)}
//           //  onMouseLeave={() => setIsDropdownOpen11(false)}>
//            onMouseEnter={() => setActiveDropdownd(true)}
//               onMouseLeave={() => setActiveDropdownd(false)}>

//             <a href="#">Directory</a>
//             {activeDropdownd && (
//               <div className="dropdown-content">
//                 <div className="column">
//                  <Link to='/leadersPage'> <p>Lion Leaders of India 2025-2026</p>
// </Link>
//                 </div></div>
//             )}

//           </li>
//              <li className="dropdown" 
//           // onMouseEnter={() => setIsDropdownOpen11(true)}
//           //  onMouseLeave={() => setIsDropdownOpen11(false)}>
//            onMouseEnter={() => setActiveDropdowndM(true)}
//               onMouseLeave={() => setActiveDropdowndM(false)}>

//             <a href="#">Magazine</a>
//             {activeDropdowndM && (
//               <div className="dropdown-content">
//                 <div className="column">
//                  <Link to='/Flipbook'> <p>Flip Book</p>
// </Link>
//                 </div></div>
//             )}

//           </li>
//           </ul>
//         </div>
//       )}
//     </>
//   );
// };

// export default Navbar;


import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { FaHome } from "react-icons/fa";
import logo from './logo.png'
import logo1 from '../images/logo.png'
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Modal from "react-modal";
import { TranslateClient, TranslateTextCommand } from "@aws-sdk/client-translate";
import AWS from 'aws-sdk';
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";



// import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
// Bind modal to your app element
Modal.setAppElement("#root");




const translateClient = new TranslateClient({
  region: "ap-south-1",
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: "ap-south-1" },
    identityPoolId: "ap-south-1:5e38b532-65c3-4346-9e23-4c6d33ba554d", // ✅ must be lowercase
  }),
});



export async function translateText(text, targetLang) {
  try {
    if (!text || !targetLang) return text;

    // Build cache key (unique per text + language)
    const cacheKey = `translation_${targetLang}_${text}`;

    // 1. Check if cached
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      return cached; // ⚡ Instant from cache
    }

    // 2. Otherwise call AWS
    const command = new TranslateTextCommand({
      Text: text,
      SourceLanguageCode: "auto",
      TargetLanguageCode: targetLang,
    });

    const response = await translateClient.send(command);
    const translated = response.TranslatedText;

    // 3. Save to cache
    localStorage.setItem(cacheKey, translated);

    return translated;
  } catch (err) {
    console.error("Translation error:", err);
    return text;
  }
}



// console.log("AWS REGION:", process.env.REACT_APP_AWS_REGION);
// console.log("AWS KEY:", process.env.REACT_APP_AWS_ACCESS_KEY_ID);

// console.log("ENV TEST", process.env);


const Navbar = ({ selectedLang, setSelectedLang }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);


  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeDropdownd, setActiveDropdownd] = useState(null);
  const [activeDropdowndISM, setActiveDropdowndISM] = useState(null);
  const [activeDropdowndM, setActiveDropdowndM] = useState(null);
  const toggleDropdown = (name) => {
    setActiveDropdown(activeDropdown === name ? null : name);
  };

  const [activeDropdown1, setActiveDropdown1] = useState(null);

  const toggleDropdown1 = (name) => {
    setActiveDropdown1(activeDropdown === name ? null : name);
  };


  const [menus, setMenus] = useState([]);

  // useEffect(() => {
  //   axios.get("https://lcoiapi.emedha.in/appi/menus")
  //     .then(res => {
  //       setMenus(res.data);
  //     })
  //     .catch(err => {
  //       console.error("Failed to fetch menus", err);
  //     });
  // }, []);


  // language 

  const [isLangModalOpen, setIsLangModalOpen] = useState(false);
  // const [selectedLang, setSelectedLang] = useState("English");
  // console.log('this is Navbar selectedLang', selectedLang)


  const indianLanguages = [
    { label: "English", code: "en" },
    { label: "हिन्दी (Hindi)", code: "hi" },
    { label: "বাংলা (Bengali)", code: "bn" },
    { label: "తెలుగు (Telugu)", code: "te" },
    { label: "मराठी (Marathi)", code: "mr" },
    { label: "தமிழ் (Tamil)", code: "ta" },
    { label: "ગુજરાતી (Gujarati)", code: "gu" },
    { label: "ಕನ್ನಡ (Kannada)", code: "kn" },
    { label: "മലയാളം (Malayalam)", code: "ml" },
    { label: "ਪੰਜਾਬੀ (Punjabi)", code: "pa" },
    { label: "ଓଡ଼ିଆ (Odia)", code: "or" },
    { label: "অসমীয়া (Assamese)", code: "as" },
    { label: "उर्दू (Urdu)", code: "ur" },
    { label: "संस्कृत (Sanskrit)", code: "sa" }, // limited support
    { label: "Maithili", code: "mai" },          // AWS may not support yet
    { label: "Konkani", code: "kok" }           // AWS may not support yet
  ];

  const handleLanguageSelect = (lang) => {
    // setSelectedLang(lang);
    setSelectedLang(lang.code);
    setIsLangModalOpen(false);
    // 👉 You can also store in localStorage or call API to persist selection
  };





  // useEffect(() => {
  //   let isMounted = true; 
  //   async function fetchMenus() {
  //     try {
  //       const res = await axios.get("https://lcoiapi.emedha.in/appi/menus");
  //       let data = res.data;
  //       if (isMounted) setMenus(data);
  //       if (selectedLang !== "en") {
  //         const translatedData = await Promise.all(
  //           data.map(async (menu) => ({
  //             ...menu,
  //             name: await translateText(menu.name, selectedLang) || menu.name,
  //             submenus: await Promise.all(
  //               menu.submenus.map(async (sub) => ({
  //                 ...sub,
  //                 name: await translateText(sub.name, selectedLang) || sub.name,
  //                 subPlusMenus: await Promise.all(
  //                   sub.subPlusMenus.map(async (sp) => ({
  //                     ...sp,
  //                     name: await translateText(sp.name, selectedLang) || sp.name,
  //                   }))
  //                 ),
  //               }))
  //             ),
  //           }))
  //         );

  //         if (isMounted) setMenus(translatedData); 
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch menus", err);
  //     }
  //   }

  //   fetchMenus();

  //   return () => {
  //     isMounted = false;
  //   };
  // }, [selectedLang]);

  // useEffect(() => {
  //   async function fetchMenus() {
  //     try {
  //       // Fetch both APIs
  //       const [menusRes, menusDataRes] = await Promise.all([
  //         axios.get("https://lcoiapi.emedha.in/appi/menus"),
  //         axios.get("https://lcoiapi.emedha.in/appi/api/menu/menus_data")
  //       ]);

  //       const menus = menusRes.data;
  //       const menusData = menusDataRes.data; // contains flag + url

  //       // Merge logic
  //       const mergedMenus = menus.map(menu => {
  //         // Check submenus for flag = 1
  //         const firstSubWithUrl = menusData.find(
  //           d => d.menus_id === menu.id && d.flag === 1 && d.sub_menus_id
  //         );

  //         return {
  //           ...menu,
  //           // assign url from first submenu with flag=1
  //           url: firstSubWithUrl ? firstSubWithUrl.url : null,
  //           submenus: menu.submenus.map(sub => {
  //             const dbMatch = menusData.find(
  //               d => d.menus_id === menu.id && d.sub_menus_id === sub.id && !d.sub_plus_menus_id
  //             );
  //             return {
  //               ...sub,
  //               url: dbMatch?.flag === 1 ? dbMatch.url : null,
  //               subPlusMenus: sub.subPlusMenus.map(sp => {
  //                 const dbMatchSp = menusData.find(
  //                   d =>
  //                     d.menus_id === menu.id &&
  //                     d.sub_menus_id === sub.id &&
  //                     d.sub_plus_menus_id === sp.id
  //                 );
  //                 return {
  //                   ...sp,
  //                   url: dbMatchSp?.flag === 1 ? dbMatchSp.url : null,
  //                 };
  //               }),
  //             };
  //           }),
  //         };
  //       });



  //       setMenus(mergedMenus);
  //     } catch (err) {
  //       console.error("Failed to fetch menus", err);
  //     }
  //   }

  //   fetchMenus();
  // }, []);

  useEffect(() => {
    let isMounted = true;

    async function fetchMenus() {
      try {
        // Fetch both APIs
        const [menusRes, menusDataRes] = await Promise.all([
          axios.get("https://lcoiapi.emedha.in/appi/menus"),
          axios.get("https://lcoiapi.emedha.in/appi/api/menu/menus_data")
        ]);

        const menus = menusRes.data;
        const menusData = menusDataRes.data;

        // Merge logic
        const mergedMenus = menus.map(menu => {
          const firstSubWithUrl = menusData.find(
            d => d.menus_id === menu.id && d.flag === 1 && d.sub_menus_id
          );

          return {
            ...menu,
            url: firstSubWithUrl ? firstSubWithUrl.url : null,
            submenus: menu.submenus.map(sub => {
              const dbMatch = menusData.find(
                d => d.menus_id === menu.id &&
                  d.sub_menus_id === sub.id &&
                  !d.sub_plus_menus_id
              );
              return {
                ...sub,
                url: dbMatch?.flag === 1 ? dbMatch.url : null,
                subPlusMenus: sub.subPlusMenus.map(sp => {
                  const dbMatchSp = menusData.find(
                    d => d.menus_id === menu.id &&
                      d.sub_menus_id === sub.id &&
                      d.sub_plus_menus_id === sp.id
                  );
                  return {
                    ...sp,
                    url: dbMatchSp?.flag === 1 ? dbMatchSp.url : null,
                  };
                }),
              };
            }),
          };
        });

        // 🌍 Translate menu names if not English
        let finalMenus = mergedMenus;
        if (selectedLang !== "en") {
          finalMenus = await Promise.all(
            mergedMenus.map(async menu => ({
              ...menu,
              name: await translateText(menu.name, selectedLang) || menu.name,
              submenus: await Promise.all(
                menu.submenus.map(async sub => ({
                  ...sub,
                  name: await translateText(sub.name, selectedLang) || sub.name,
                  subPlusMenus: await Promise.all(
                    sub.subPlusMenus.map(async sp => ({
                      ...sp,
                      name: await translateText(sp.name, selectedLang) || sp.name,
                    }))
                  ),
                }))
              ),
            }))
          );
        }

        if (isMounted) setMenus(finalMenus);

      } catch (err) {
        console.error("Failed to fetch menus", err);
      }
    }

    fetchMenus();
    return () => { isMounted = false };
  }, [selectedLang]);   // 🔑 Now reruns when language changes


  const [translated, setTranslated] = useState({
    directory: "",
    lionLeaders: "Lion Leaders of India 2026-2027",
    magazine: "",
    flipBook: "",
    LionsInternational: "",
    SelectLanguage: "",
    Donate: "",





    // menus: []
  });

  useEffect(() => {
    async function translateAll() {
      const englishTexts = {
        isame: "Isame",
        directory: "Directory",
        lionLeaders: "Lion Leaders of India 2026-2027",
        magazine: "Magazine",
        flipBook: "Flip Book",
        LionsInternational: "Lions International",
        SelectLanguage: "Select Language",
        Donate: "Donate",
        isame2025: "Isame2025"





      };

      setTranslated({
        isame2025: await translateText(englishTexts.isame2025, selectedLang),
        isame: await translateText(englishTexts.isame, selectedLang),
        directory: await translateText(englishTexts.directory, selectedLang),
        lionLeaders: await translateText(englishTexts.lionLeaders, selectedLang),
        magazine: await translateText(englishTexts.magazine, selectedLang),
        flipBook: await translateText(englishTexts.flipBook, selectedLang),
        LionsInternational: await translateText(englishTexts.LionsInternational, selectedLang),
        SelectLanguage: await translateText(englishTexts.SelectLanguage, selectedLang),
        Donate: await translateText(englishTexts.Donate, selectedLang),

        // services: translatedServices,
        // impacts: translatedImpacts,
      });
    }

    translateAll();
  }, [selectedLang]);

  // Define month options


  //   const [activeDropdowndMo, setActiveDropdowndMo] = useState(false);
  //       const [selectedMonth, setSelectedMonth] = useState('');
  //   const [pdfUrl, setPdfUrl] = useState(null);
  //   const [error, setError] = useState('');
  //     const navigate = useNavigate();
  //       const [selectedLanguage, setSelectedLanguage] = useState('English');
  //   const [availableMonths, setAvailableMonths] = useState([]);



  //   const months = [
  //     'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  //   ];

  //   const handleMonthSelect = (month) => {
  //     setSelectedMonth(month);
  //     fetchPdfForMonth(month, selectedLanguage);
  //   };

  //   const handleLanguageSelectPdf = (language) => {
  //     setSelectedLanguage(language);
  //     fetchPdfForMonth(selectedMonth, language);
  //   };


  //  const fetchPdfForMonth = async (month, language) => {
  //     try {
  //       const response = await axios.get('https://lcoiapi.emedha.in/pdf/api/get-pdf', {
  //         params: { month, language }
  //       });
  //       const data = response.data;
  //       if (data.pdf_url) {
  //         setPdfUrl(data.pdf_url);
  //         setError('');
  //         navigate('/Flipbook', { state: { pdfUrl: data.pdf_url } });
  //       } else {
  //         setPdfUrl(null);
  //         setError(`No PDF found for ${month} in ${language}`);
  //       }
  //     } catch (error) {
  //       setPdfUrl(null);
  //       setError('Error fetching PDF');
  //     }
  //   };




  const [activeDropdowndMo, setActiveDropdowndMo] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();


  const [selectedLanguage, setSelectedLanguage] = useState('Select Language');
  const [availableMonths, setAvailableMonths] = useState([]);

  // Define months (this is static, will be filtered later)
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Handle month selection
  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
    fetchPdfForMonth(month, selectedLanguage);
  };

  // Handle language selection
  const handleLanguageSelectPdf = (language) => {
    setSelectedLanguage(language);
    fetchAvailableMonths(language); // Fetch months based on selected language
  };

  // Fetch available months based on selected language
  const fetchAvailableMonths = async (language) => {
    try {
      const response = await axios.get(`https://lcoiapi.emedha.in/pdf/api/get-months-by-language`, { params: { language } });
      const months = response.data;
      setAvailableMonths(months);
      setError('');
    } catch (error) {
      setError('Error fetching months');
    }
  };

  // Fetch PDF for the selected month and language
  const fetchPdfForMonth = async (month, language) => {
    try {
      const response = await axios.get('https://lcoiapi.emedha.in/pdf/api/get-pdf', {
        params: { month, language }
      });
      const data = response.data;
      if (data.pdf_url) {
        setPdfUrl(data.pdf_url);
        setError('');
        navigate('/Flipbook', { state: { pdfUrl: data.pdf_url } }); // Navigate to Flipbook
      } else {
        setPdfUrl(null);
        setError(`No PDF found for ${month} in ${language}`);
      }
    } catch (error) {
      setPdfUrl(null);
      setError('Error fetching PDF');
    }
  };



  return (
    <>
      {/* Top Alert */}
      <div className="top-bar">
        {/* View the <a href="#">Official Call</a> and <a href="#">Notice of Amendments</a> to be voted on by the Delegates at the 2025 International Convention in Orlando. */}
      </div>


      <div className="middle-header1">
        <div className="logo">
          <img src={logo} alt="logo" className="glow-logo" style={{ height: '70px', width: '80px' }} />
          <span style={{ color: 'white' }}>
            {translated.LionsInternational}
          </span>
        </div>

        <div className="header-buttons">
          {/* <button className="join">Join</button> */}
          <button
            className="donate"
            onClick={() => window.open("https://www.lcifindia.org/donate.php", "_blank")}
          >
            {translated.Donate}
          </button>

          <button className="language-btn" onClick={() => setIsLangModalOpen(true)}>
            {selectedLang} 🌐
          </button>
          {/* <span className="search">🔍</span> */}
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </button>
        </div>

      </div>
      {/* Language Selection Modal */}
      {/* <Modal
        isOpen={isLangModalOpen}
        onRequestClose={() => setIsLangModalOpen(false)}
        contentLabel="Select Language"
        style={{
          content: { width: "300px", height: "auto", margin: "auto", borderRadius: "12px", padding: "20px", textAlign: "center", background: "#f9f9f9", boxShadow: "0px 4px 12px rgba(0,0,0,0.2)" },
          overlay: { backgroundColor: "rgba(0,0,0,0.4)", display: "flex", justifyContent: "center", alignItems: "center" }
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#005399" }}>{translated.SelectLanguage}</h3>

        <div style={{ maxHeight: "500px", overflowY: "auto" }}>
          {indianLanguages.map((lang, i) => (
            <button key={i} onClick={() => handleLanguageSelect(lang)} style={{ display: "block", width: "100%", padding: "8px", margin: "5px 0", border: "1px solid #ddd", borderRadius: "6px", background: selectedLang === lang ? "#005399" : "#fff", color: selectedLang === lang ? "#fff" : "#333", cursor: "pointer" }}>
              {lang.label}
            </button>
          ))}
        </div>

        <button onClick={() => setIsLangModalOpen(false)} style={{ marginTop: "15px", padding: "8px 16px", background: "#999", border: "none", borderRadius: "6px", color: "#fff", cursor: "pointer" }}>Close</button>
      </Modal> */}

      {/* Language Selection Modal (Inline, not react-modal) */}
      {isLangModalOpen && (
        <div
          className="custom-modal"
          style={{
            position: "absolute",   // stays inside header
            top: "80px",            // just below navbar
            right: "20px",
            width: "280px",
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: "10px",
            padding: "15px",
            zIndex: 1000,           // sits above navbar but not full-screen overlay
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          <h3 style={{ marginBottom: "12px", color: "#005399" }}>
            {translated.SelectLanguage}
          </h3>

          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            {indianLanguages.map((lang, i) => (
              <button
                key={i}
                onClick={() => handleLanguageSelect(lang)}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "8px",
                  margin: "5px 0",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  background: selectedLang === lang.code ? "#005399" : "#fff",
                  color: selectedLang === lang.code ? "#fff" : "#333",
                  cursor: "pointer",
                }}
              >
                {lang.label}
              </button>
            ))}
          </div>

          <button
            onClick={() => setIsLangModalOpen(false)}
            style={{
              marginTop: "10px",
              padding: "8px 12px",
              background: "#999",
              border: "none",
              borderRadius: "6px",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      )}


      {/* Main Navbar */}
      <div className="main-navbar">
        <ul className="menu">
          <li> <a href="/"><FaHome style={{ fontSize: '30px' }} /></a></li>

          {menus.map(menu => (
            <li key={menu.id}
              className="dropdown"
              onMouseEnter={() => setActiveDropdown(menu.id)}
              onMouseLeave={() => setActiveDropdown(null)}>

              <span style={{ color: "#005399", cursor: menu.url ? "pointer" : "default", }}
                onClick={() => {
                  console.log("Clicked Menu:", menu.name, "URL:", menu.url);
                  if (menu.url) {
                    window.open(menu.url, "_blank");
                  }
                }}>
                {menu.name}
              </span>




              {activeDropdown === menu.id && (
                <div className="dropdown-content">
                  <div className="column">
                    {menu.submenus.map(submenu => (
                      submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
                        <div className="nested-dropdown" key={submenu.id}>
                          {submenu.url ? (
                            // external url (flag=1)
                            <p
                              className="has-submenu"
                              style={{ cursor: "pointer", color: "#005399" }}
                              onClick={() => window.open(submenu.url, "_blank")}
                            >
                              {submenu.name} ▸
                            </p>
                          ) : (
                            // fallback internal link
                            <p className="has-submenu">
                              <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
                                {submenu.name} ▸
                              </Link>
                            </p>
                          )}

                          <div className="side-dropdown">
                            {submenu.subPlusMenus.map(subPlus => (
                              subPlus.url ? (
                                // external url (flag=1)
                                <p key={subPlus.id} style={{ cursor: "pointer", color: "#005399" }}
                                  onClick={() => window.open(subPlus.url, "_blank")}
                                >
                                  {subPlus.name}
                                </p>
                              ) : (
                                // fallback internal link
                                <p key={subPlus.id}>
                                  <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}&sub_plus_menus_id=${subPlus.id}`}>
                                    {subPlus.name}
                                  </Link>
                                </p>
                              )
                            ))}
                          </div>
                        </div>
                      ) : (
                        submenu.url ? (
                          // external url (flag=1)
                          <p key={submenu.id} style={{ cursor: "pointer", color: "#005399" }}
                            onClick={() => window.open(submenu.url, "_blank")}
                          >
                            {submenu.name}
                          </p>
                        ) : (
                          // fallback internal link
                          <Link key={submenu.id} to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
                            <p>{submenu.name}</p>
                          </Link>
                        )
                      )
                    ))}


                  </div>
                </div>
              )}
            </li>
          ))}
          <li className="dropdown" onMouseEnter={() => setActiveDropdownd(true)} onMouseLeave={() => setActiveDropdownd(false)}>

            <a href="#">{translated.directory}</a>
            {activeDropdownd && (
              <div className="dropdown-content">
                <div className="column">
                  <Link to='/leadersPage'>
                    <p>{translated.lionLeaders}</p>
                  </Link>
                </div></div>
            )}

          </li>
          {/* <li className="dropdown" onMouseEnter={() => setActiveDropdowndISM(true)} onMouseLeave={() => setActiveDropdowndISM(false)}>

            <a href="#">{translated.isame}</a>
            {activeDropdowndISM && (
              <div className="dropdown-content">
                <div className="column">
                  <Link to='/isame2025'>
                    <p>{translated.isame2025}</p>
                  </Link>
                </div></div>
            )}

          </li> */}

        </ul>
      </div>

      {menuOpen && (
        <div className={`mobile-sidebar ${menuOpen ? 'open' : ''}`}>
          <button className="close-btn" onClick={() => setMenuOpen(false)}>×</button>
          <ul className="mobile-menu">
            <li><a href="/"><FaHome /></a></li>


            {menus.map(menu => (
              <li
                key={menu.id}
                className="dropdown"
                // onMouseEnter={() => setIsDropdownOpen(true)}
                // onMouseLeave={() => setIsDropdownOpen(false)}
                onMouseEnter={() => setActiveDropdown(menu.id)}
                onMouseLeave={() => setActiveDropdown(null)}

              >
                {/* <span style={{ color: '#005399' }}>   <Link to={`/content?menus_id=${menu.id}`}>{menu.name} </Link></span> */}
                <span style={{ color: '#005399' }}>   {menu.name} </span>
                {/* <span style={{ color: "#005399", cursor: menu.url ? "pointer" : "default", }}
                onClick={() => {
                  console.log("Clicked Menu:", menu.name, "URL:", menu.url);
                  if (menu.url) {
                    window.open(menu.url, "_blank");
                  }
                }}>
                {menu.name}
              </span> */}
                {/* {isDropdownOpen && ( */}
                {activeDropdown === menu.id && (

                  <div className="dropdown-content">
                    <div className="column">

                      {/* {menu.submenus.map(submenu => (
                        submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
                          <div className="nested-dropdown" key={submenu.id}>
                            <p className="has-submenu"><Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>{submenu.name} ▸  </Link></p>
                            <d v className="side-dropdown">
                              {submenu.subPlusMenus.map(subPlus => (
                                // <Link key={subPlus.id} to={`/${subPlus.name.replace(/\s+/g, '')}`}>
                                <p>  <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}&sub_plus_menus_id=${subPlus.id}`}>{subPlus.name}   </Link></p>
                                // </Link>
                              ))}
                            </d>
                          </div>
                        ) : (
                          // <Link key={submenu.id} to={`/${submenu.name.replace(/\s+/g, '')}`}>
                          <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
                            <p>{submenu.name}</p>
                          </Link>
                        )
                      ))} */}

                      {menu.submenus.map(submenu => (
                        submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
                          <div className="nested-dropdown" key={submenu.id}>
                            {submenu.url ? (
                              // external url (flag=1)
                              <p
                                className="has-submenu"
                                style={{ cursor: "pointer", color: "#005399" }}
                                onClick={() => window.open(submenu.url, "_blank")}
                              >
                                {submenu.name} ▸
                              </p>
                            ) : (
                              // fallback internal link
                              <p className="has-submenu">
                                <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
                                  {submenu.name} ▸
                                </Link>
                              </p>
                            )}

                            <div className="side-dropdown">
                              {submenu.subPlusMenus.map(subPlus => (
                                subPlus.url ? (
                                  // external url (flag=1)
                                  <p key={subPlus.id} style={{ cursor: "pointer", color: "#005399" }}
                                    onClick={() => window.open(subPlus.url, "_blank")}
                                  >
                                    {subPlus.name}
                                  </p>
                                ) : (
                                  // fallback internal link
                                  <p key={subPlus.id}>
                                    <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}&sub_plus_menus_id=${subPlus.id}`}>
                                      {subPlus.name}
                                    </Link>
                                  </p>
                                )
                              ))}
                            </div>
                          </div>
                        ) : (
                          submenu.url ? (
                            // external url (flag=1)
                            <p key={submenu.id} style={{ cursor: "pointer", color: "#005399" }}
                              onClick={() => window.open(submenu.url, "_blank")}
                            >
                              {submenu.name}
                            </p>
                          ) : (
                            // fallback internal link
                            <Link key={submenu.id} to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
                              <p>{submenu.name}</p>
                            </Link>
                          )
                        )
                      ))}

                    </div>
                  </div>
                )}
              </li>
            ))}
            <li className="dropdown"
              // onMouseEnter={() => setIsDropdownOpen11(true)}
              //  onMouseLeave={() => setIsDropdownOpen11(false)}>
              onMouseEnter={() => setActiveDropdownd(true)}
              onMouseLeave={() => setActiveDropdownd(false)}>

              <a href="#">Directoryy</a>
              {activeDropdownd && (
                <div className="dropdown-content">
                  <div className="column">
                    <Link to='/leadersPage'> <p>Lion Leaders of India 2026-2027</p>
                    </Link>
                  </div></div>
              )}

            </li>
            {/* <li className="dropdown"
              // onMouseEnter={() => setIsDropdownOpen11(true)}
              //  onMouseLeave={() => setIsDropdownOpen11(false)}>
              onMouseEnter={() => setActiveDropdowndM(true)}
              onMouseLeave={() => setActiveDropdowndM(false)}>

              <a href="#">Magazine</a>
              {activeDropdowndM && (
                <div className="dropdown-content">
                  <div className="column">
                    <Link to='/Flipbook'> <p>Flip Book</p>
                    </Link>
                  </div></div>
              )}

            </li> */}
            {/* <li
          className="dropdown"
          onMouseEnter={() => setActiveDropdowndM(true)}
          onMouseLeave={() => setActiveDropdowndM(false)}
        >
          <a href="#">Magazine</a>
          {activeDropdowndM && (
            <div className="dropdown-content">
              <div className="column">
                <ul>
                  {months.map((month) => (
                    <li key={month} onClick={() => handleMonthSelect(month)}>
                      {month}
                    </li>
                  ))}
                </ul>
               
                <div>
                  <label>Select Language: </label>
                  <select
                    value={selectedLanguage}
                    onChange={(e) => handleLanguageSelectPdf(e.target.value)}
                    style={{ padding: '8px', marginTop: '10px' }}
                  >
                    <option value="English">English</option>
                    <option value="Hindi">Hindi</option>
                  </select>
                </div>
              </div>
            </div>
          )}
        </li> */}

            {/* <li
  className="dropdown"
  onMouseEnter={() => setActiveDropdowndMo(true)}
  onMouseLeave={() => setActiveDropdowndMo(false)}
>
  {/* <a href="#">Magazine</a> *
  <a href="#">{translated.magazine}</a>
  {activeDropdowndMo && (
    <div className="dropdown-content" style={{ display: 'flex', justifyContent: 'flex-start', padding: '10px', width: '130px', height:'200px' }}>
      <div className="column" style={{ flex: 1, paddingRight: '10px' }}>
        {/* Language selection *
        <div >
          <label  style={{
              width: '100%',
              boxSizing: 'border-box',
              fontSize: '14px'
            }}>Language: </label>
          <select
            value={selectedLanguage}
            onChange={(e) => {
              handleLanguageSelectPdf(e.target.value);
              // Don't close the dropdown when a language is selected
           setActiveDropdowndMo(true)
            }}
            style={{
              padding: '8px',
              marginTop: '10px',
              width: '100%',
              boxSizing: 'border-box',
              fontSize: '14px'
            }}
          >
        <option value="Select Language">Select Language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
          </select>
        </div>
      </div>

      {/* Display months based on selected language *
      <div style={{ flex: 1 }}>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {availableMonths.length > 0 ? (
            availableMonths.map((month) => (
              <li
                key={month}
                onClick={() => handleMonthSelect(month)}
                style={{
                  padding: '8px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #ddd',
                  fontSize: '14px'
                }}
              >
                {month}
              </li>
            ))
          ) : (
            <li style={{ padding: '8px' }}>No months available</li>
          )}
        </ul>
      </div>
    </div>
  )}
</li> */}
          </ul>
        </div>
      )}
    </>
  );
};

export default Navbar;







// import React, { useEffect, useState } from "react";
// import "./Navbar.css";
// import { FaHome } from "react-icons/fa";
// import logo from './logo.png'
// import logo1 from '../images/logo.png'
// import { Link, useNavigate } from 'react-router-dom';
// import axios from "axios";
// import Modal from "react-modal";
// import { TranslateClient, TranslateTextCommand } from "@aws-sdk/client-translate";
// import AWS from 'aws-sdk';
// import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";



// // import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
// // Bind modal to your app element
// Modal.setAppElement("#root");




// const translateClient = new TranslateClient({
//   region: "ap-south-1",
//   credentials: fromCognitoIdentityPool({
//     clientConfig: { region: "ap-south-1" },
//     identityPoolId: "ap-south-1:5e38b532-65c3-4346-9e23-4c6d33ba554d", // ✅ must be lowercase
//   }),
// });



// export async function translateText(text, targetLang) {
//   try {
//     if (!text || !targetLang) return text;

//     // Build cache key (unique per text + language)
//     const cacheKey = `translation_${targetLang}_${text}`;

//     // 1. Check if cached
//     const cached = localStorage.getItem(cacheKey);
//     if (cached) {
//       return cached; // ⚡ Instant from cache
//     }

//     // 2. Otherwise call AWS
//     const command = new TranslateTextCommand({
//       Text: text,
//       SourceLanguageCode: "auto",
//       TargetLanguageCode: targetLang,
//     });

//     const response = await translateClient.send(command);
//     const translated = response.TranslatedText;

//     // 3. Save to cache
//     localStorage.setItem(cacheKey, translated);

//     return translated;
//   } catch (err) {
//     console.error("Translation error:", err);
//     return text;
//   }
// }



// console.log("AWS REGION:", process.env.REACT_APP_AWS_REGION);
// console.log("AWS KEY:", process.env.REACT_APP_AWS_ACCESS_KEY_ID);

// console.log("ENV TEST", process.env);


// const Navbar = ({ selectedLang, setSelectedLang }) => {


//   const [activeDropdowndMo, setActiveDropdowndMo] = useState(false);
// const [selectedMonth, setSelectedMonth] = useState('');
// const [pdfUrl, setPdfUrl] = useState(null);
// const [error, setError] = useState('');
//   const navigate = useNavigate();
//     const [selectedLanguage, setSelectedLanguage] = useState('English');

//   // Define month options
//   const months = [
//     'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
//   ];

//   const handleMonthSelect = (month) => {
//     setSelectedMonth(month);
//     fetchPdfForMonth(month, selectedLanguage);
//   };

//   const handleLanguageSelectPdf = (language) => {
//     setSelectedLanguage(language);
//     fetchPdfForMonth(selectedMonth, language);
//   };


//  const fetchPdfForMonth = async (month, language) => {
//     try {
//       const response = await axios.get('https://lcoiapi.emedha.in/pdf/api/get-pdf', {
//         params: { month, language }
//       });
//       const data = response.data;
//       if (data.pdf_url) {
//         setPdfUrl(data.pdf_url);
//         setError('');
//         navigate('/Flipbook', { state: { pdfUrl: data.pdf_url } });
//       } else {
//         setPdfUrl(null);
//         setError(`No PDF found for ${month} in ${language}`);
//       }
//     } catch (error) {
//       setPdfUrl(null);
//       setError('Error fetching PDF');
//     }
//   };

//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);


//   const [menuOpen, setMenuOpen] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [activeDropdownd, setActiveDropdownd] = useState(null);
//   const [activeDropdowndM, setActiveDropdowndM] = useState(null);
//   const toggleDropdown = (name) => {
//     setActiveDropdown(activeDropdown === name ? null : name);
//   };

//   const [activeDropdown1, setActiveDropdown1] = useState(null);

//   const toggleDropdown1 = (name) => {
//     setActiveDropdown1(activeDropdown === name ? null : name);
//   };


//   const [menus, setMenus] = useState([]);

//   // useEffect(() => {
//   //   axios.get("https://lcoiapi.emedha.in/appi/menus")
//   //     .then(res => {
//   //       setMenus(res.data);
//   //     })
//   //     .catch(err => {
//   //       console.error("Failed to fetch menus", err);
//   //     });
//   // }, []);


//   // language

//   const [isLangModalOpen, setIsLangModalOpen] = useState(false);
//   // const [selectedLang, setSelectedLang] = useState("English");
//   console.log('this is Navbar selectedLang', selectedLang)


//   const indianLanguages = [
//     { label: "English", code: "en" },
//     { label: "हिन्दी (Hindi)", code: "hi" },
//     { label: "বাংলা (Bengali)", code: "bn" },
//     { label: "తెలుగు (Telugu)", code: "te" },
//     { label: "मराठी (Marathi)", code: "mr" },
//     { label: "தமிழ் (Tamil)", code: "ta" },
//     { label: "ગુજરાતી (Gujarati)", code: "gu" },
//     { label: "ಕನ್ನಡ (Kannada)", code: "kn" },
//     { label: "മലയാളം (Malayalam)", code: "ml" },
//     { label: "ਪੰਜਾਬੀ (Punjabi)", code: "pa" },
//     { label: "ଓଡ଼ିଆ (Odia)", code: "or" },
//     { label: "অসমীয়া (Assamese)", code: "as" },
//     { label: "उर्दू (Urdu)", code: "ur" },
//     { label: "संस्कृत (Sanskrit)", code: "sa" }, // limited support
//     { label: "Maithili", code: "mai" },          // AWS may not support yet
//     { label: "Konkani", code: "kok" }           // AWS may not support yet
//   ];

//   const handleLanguageSelect = (lang) => {
//     // setSelectedLang(lang);
//     setSelectedLang(lang.code);
//     setIsLangModalOpen(false);
//     // 👉 You can also store in localStorage or call API to persist selection
//   };



//   useEffect(() => {
//     async function fetchMenus() {
//       try {
//         const res = await axios.get("https://lcoiapi.emedha.in/appi/menus");
//         let data = res.data;

//         if (selectedLang !== "en") {
//           data = await Promise.all(
//             data.map(async (menu) => ({
//               ...menu,
//               name: await translateText(menu.name, selectedLang),
//               submenus: await Promise.all(
//                 menu.submenus.map(async (sub) => ({
//                   ...sub,
//                   name: await translateText(sub.name, selectedLang),
//                   subPlusMenus: await Promise.all(
//                     sub.subPlusMenus.map(async (sp) => ({
//                       ...sp,
//                       name: await translateText(sp.name, selectedLang),
//                     }))
//                   ),
//                 }))
//               ),
//             }))
//           );
//         }

//         setMenus(data);
//       } catch (err) {
//         console.error("Failed to fetch menus", err);
//       }
//     }

//     fetchMenus();
//   }, [selectedLang]);


//   const [translated, setTranslated] = useState({
//     directory: "",
//     lionLeaders: "Lion Leaders of India 2025-2026",
//     magazine: "",
//     flipBook: "",
//     LionsInternational:"",
// SelectLanguage:"",
// Donate:"",





//     // menus: []
//   });

//   useEffect(() => {
//     async function translateAll() {
//       const englishTexts = {
//         directory: "Directory",
//         lionLeaders: "Lion Leaders of India 2025-2026",
//         magazine: "Magazine",
//         flipBook: "Flip Book",
//            LionsInternational:"Lions International",
// SelectLanguage:"Select Language",
// Donate:"Donate",




//       };

//       setTranslated({
//         directory: await translateText(englishTexts.directory, selectedLang),
//         lionLeaders: await translateText(englishTexts.lionLeaders, selectedLang),
//         magazine: await translateText(englishTexts.magazine, selectedLang),
//         flipBook: await translateText(englishTexts.flipBook, selectedLang),
//         LionsInternational: await translateText(englishTexts.LionsInternational, selectedLang),
//    SelectLanguage: await translateText(englishTexts.SelectLanguage, selectedLang),
//  Donate: await translateText(englishTexts.Donate, selectedLang),




//         // services: translatedServices,
//         // impacts: translatedImpacts,
//       });
//     }

//     translateAll();
//   }, [selectedLang]);


//   return (
//     <>
//       {/* Top Alert */}
//       <div className="top-bar">
//         {/* View the <a href="#">Official Call</a> and <a href="#">Notice of Amendments</a> to be voted on by the Delegates at the 2025 International Convention in Orlando. */}
//       </div>


//       <div className="middle-header1">
//         <div className="logo">
//           <img src={logo} alt="logo" className="glow-logo" style={{ height: '70px', width: '80px' }} />
//           <span style={{ color: 'white' }}>
//             {translated.LionsInternational}
//             </span>
//         </div>

//         <div className="header-buttons">
//           {/* <button className="join">Join</button> */}
//           <button className="donate">{translated.Donate}</button>
//           <button className="language-btn" onClick={() => setIsLangModalOpen(true)}>
//             {selectedLang} 🌐
//           </button>
//           {/* <span className="search">🔍</span> */}
//           <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
//             ☰
//           </button>
//         </div>

//       </div>
//       {/* Language Selection Modal */}
//       <Modal
//         isOpen={isLangModalOpen}
//         onRequestClose={() => setIsLangModalOpen(false)}
//         contentLabel="Select Language"
//         style={{
//           content: {
//             width: "300px",
//             height: "auto",
//             margin: "auto",
//             borderRadius: "12px",
//             padding: "20px",
//             textAlign: "center",
//             background: "#f9f9f9",
//             boxShadow: "0px 4px 12px rgba(0,0,0,0.2)"
//           },
//           overlay: {
//             backgroundColor: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center"
//           }
//         }}
//       >
//         <h3 style={{ marginBottom: "15px", color: "#005399" }}>{translated.SelectLanguage}</h3>

//         <div style={{ maxHeight: "500px", overflowY: "auto" }}>
//           {indianLanguages.map((lang, i) => (
//             <button
//               key={i}
//               onClick={() => handleLanguageSelect(lang)}
//               style={{
//                 display: "block",
//                 width: "100%",
//                 padding: "8px",
//                 margin: "5px 0",
//                 border: "1px solid #ddd",
//                 borderRadius: "6px",
//                 background: selectedLang === lang ? "#005399" : "#fff",
//                 color: selectedLang === lang ? "#fff" : "#333",
//                 cursor: "pointer"
//               }}
//             >
//               {lang.label}
//             </button>
//           ))}
//         </div>

//         <button
//           onClick={() => setIsLangModalOpen(false)}
//           style={{
//             marginTop: "15px",
//             padding: "8px 16px",
//             background: "#999",
//             border: "none",
//             borderRadius: "6px",
//             color: "#fff",
//             cursor: "pointer"
//           }}
//         >
//           Close
//         </button>
//       </Modal>

//       {/* Main Navbar */}
//       <div className="main-navbar">
//         <ul className="menu">
//           <li> <a href="/"><FaHome style={{ fontSize: '30px' }} /></a></li>

//           {menus.map(menu => (
//             <li
//               key={menu.id}
//               className="dropdown"
//               // onMouseEnter={() => setIsDropdownOpen(true)}
//               // onMouseLeave={() => setIsDropdownOpen(false)}
//               onMouseEnter={() => setActiveDropdown(menu.id)}
//               onMouseLeave={() => setActiveDropdown(null)}

//             >
//               {/* <span style={{ color: '#005399' }}>   <Link to={`/content?menus_id=${menu.id}`}>{menu.name} </Link></span> */}
//               <span style={{ color: '#005399' }}>   {menu.name} </span>
//               {/* {isDropdownOpen && ( */}
//               {activeDropdown === menu.id && (

//                 <div className="dropdown-content">
//                   <div className="column">

//                     {menu.submenus.map(submenu => (
//                       submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
//                         <div className="nested-dropdown" key={submenu.id}>
//                           <p className="has-submenu"><Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>{submenu.name} ▸  </Link></p>
//                           <d v className="side-dropdown">
//                             {submenu.subPlusMenus.map(subPlus => (
//                               // <Link key={subPlus.id} to={`/${subPlus.name.replace(/\s+/g, '')}`}>
//                               <p>  <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}&sub_plus_menus_id=${subPlus.id}`}>{subPlus.name}   </Link></p>
//                               // </Link>
//                             ))}
//                           </d>
//                         </div>
//                       ) : (
//                         // <Link key={submenu.id} to={`/${submenu.name.replace(/\s+/g, '')}`}>
//                         <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
//                           <p>{submenu.name}</p>
//                         </Link>
//                       )
//                     ))}

//                   </div>
//                 </div>
//               )}
//             </li>
//           ))}
//           <li className="dropdown"
//             // onMouseEnter={() => setIsDropdownOpen11(true)}
//             //  onMouseLeave={() => setIsDropdownOpen11(false)}>
//             onMouseEnter={() => setActiveDropdownd(true)}
//             onMouseLeave={() => setActiveDropdownd(false)}>

//             <a href="#">
//               {translated.directory}
//             </a>
//             {activeDropdownd && (
//               <div className="dropdown-content">
//                 <div className="column">
//                   <Link to='/leadersPage'>
//                     {/* <p>Lion Leaders of India 2025-2026</p> */}
//                     <p>{translated.lionLeaders}</p>
//                   </Link>
//                 </div></div>
//             )}

//           </li>
//   <div>
//       <ul>
//         <li
//           className="dropdown"
//           onMouseEnter={() => setActiveDropdowndM(true)}
//           onMouseLeave={() => setActiveDropdowndM(false)}
//         >
//           <a href="#">Magazine</a>
//           {activeDropdowndM && (
//             <div className="dropdown-content">
//               <div className="column">
//                 <ul>
//                   {months.map((month) => (
//                     <li key={month} onClick={() => handleMonthSelect(month)}>
//                       {month}
//                     </li>
//                   ))}
//                 </ul>
//                 {/* Language selection */}
//                 <div>
//                   <label>Select Language: </label>
//                   <select
//                     value={selectedLanguage}
//                     onChange={(e) => handleLanguageSelectPdf(e.target.value)}
//                     style={{ padding: '8px', marginTop: '10px' }}
//                   >
//                     <option value="English">English</option>
//                     <option value="Hindi">Hindi</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//           )}
//         </li>
//       </ul>

//       {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
//     </div>
//         </ul>
//       </div>

//       {menuOpen && (
//         <div className={`mobile-sidebar ${menuOpen ? 'open' : ''}`}>
//           <button className="close-btn" onClick={() => setMenuOpen(false)}>×</button>
//           <ul className="mobile-menu">
//             <li><a href="/"><FaHome /></a></li>


//             {menus.map(menu => (
//               <li
//                 key={menu.id}
//                 className="dropdown"
//                 // onMouseEnter={() => setIsDropdownOpen(true)}
//                 // onMouseLeave={() => setIsDropdownOpen(false)}
//                 onMouseEnter={() => setActiveDropdown(menu.id)}
//                 onMouseLeave={() => setActiveDropdown(null)}

//               >
//                 {/* <span style={{ color: '#005399' }}>   <Link to={`/content?menus_id=${menu.id}`}>{menu.name} </Link></span> */}
//                 <span style={{ color: '#005399' }}>   {menu.name} </span>
//                 {/* {isDropdownOpen && ( */}
//                 {activeDropdown === menu.id && (

//                   <div className="dropdown-content">
//                     <div className="column">

//                       {menu.submenus.map(submenu => (
//                         submenu.subPlusMenus && submenu.subPlusMenus.length > 0 ? (
//                           <div className="nested-dropdown" key={submenu.id}>
//                             <p className="has-submenu"><Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>{submenu.name} ▸  </Link></p>
//                             <d v className="side-dropdown">
//                               {submenu.subPlusMenus.map(subPlus => (
//                                 // <Link key={subPlus.id} to={`/${subPlus.name.replace(/\s+/g, '')}`}>
//                                 <p>  <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}&sub_plus_menus_id=${subPlus.id}`}>{subPlus.name}   </Link></p>
//                                 // </Link>
//                               ))}
//                             </d>
//                           </div>
//                         ) : (
//                           // <Link key={submenu.id} to={`/${submenu.name.replace(/\s+/g, '')}`}>
//                           <Link to={`/content?menus_id=${menu.id}&sub_menus_id=${submenu.id}`}>
//                             <p>{submenu.name}</p>
//                           </Link>
//                         )
//                       ))}

//                     </div>
//                   </div>
//                 )}
//               </li>
//             ))}
//             <li className="dropdown"
//               // onMouseEnter={() => setIsDropdownOpen11(true)}
//               //  onMouseLeave={() => setIsDropdownOpen11(false)}>
//               onMouseEnter={() => setActiveDropdownd(true)}
//               onMouseLeave={() => setActiveDropdownd(false)}>

//               <a href="#">Directory</a>
//               {activeDropdownd && (
//                 <div className="dropdown-content">
//                   <div className="column">
//                     <Link to='/leadersPage'> <p>Lion Leaders of India 2025-2026</p>
//                     </Link>
//                   </div></div>
//               )}

//             </li>
//   <div>
//       <ul>
// <li
//   className="dropdown"
//   onMouseEnter={() => setActiveDropdowndM(true)}
//   onMouseLeave={() => setActiveDropdowndM(false)}
// >
//   <a href="#">Magazine</a>
//   {activeDropdowndM && (
//     <div className="dropdown-content">
//       <div className="column">
//         <ul>
//           {months.map((month) => (
//             <li key={month} onClick={() => handleMonthSelect(month)}>
//               {month}
//             </li>
//           ))}
//         </ul>
//         {/* Language selection */}
//         <div>
//           <label>Select Language: </label>
//           <select
//             value={selectedLanguage}
//             onChange={(e) => handleLanguageSelectPdf(e.target.value)}
//             style={{ padding: '8px', marginTop: '10px' }}
//           >
//             <option value="English">English</option>
//             <option value="Hindi">Hindi</option>
//           </select>
//         </div>
//       </div>
//     </div>
//   )}
// </li>
//       </ul>

//       {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
//     </div>
//           </ul>
//         </div>
//       )}
//     </>
//   );
// };

// export default Navbar;

